/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-use-before-define */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { seelectEntidad } from 'store/auth';
import { useSelector } from 'react-redux';
import {
  Form,
  Button,
  Row,
  Col,
  Input,
  Spin,
  Card,
  Modal,
  Typography,
  DatePicker,
  Alert,
  Menu,
  notification,
  Tabs,
  message,
  Upload,
  Switch,
  Tag,
  Select as AntSelect,
} from 'antd';
import {
  FileExcelOutlined,
  FilePdfOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UnorderedListOutlined,
  SyncOutlined,
  UploadOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { FaMoneyBill, FaGgCircle } from 'react-icons/fa';
import API from 'utils/api';
import { formatReceivedValues } from 'utils/formatValues';
import { API_HOST } from 'utils/env';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import currencyFormatter from 'utils/currencyFormatter';
import ModalErroresControls from 'components/ModalErroresControls';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import {
  getEstadosGlobales,
  getTiposDeNomina,
  getPeriodicidadesDePagos,
} from 'api/catalogos/index';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getBancos } from 'api/configuraciones/bancos';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getSujetoDeNominaLabels } from 'utils/sujetosDeNomina';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getEmpleado, getEmpleadosWithoutFilter } from 'api/estructuraOrganizacional/empleados';
import { getBecariosWithoutFilter } from 'api/catalogos/Becario';
import { getHonorariosAsimiladosWithoutFilter } from 'api/catalogos/HonorarioAsimilado';
import {
  getCalculosDeNominas,
  postCalculosDeNominas,
  getCalculoDeNomina,
  autorizarNomina,
  getNominasErrores,
  cancelarNomina,
  patchCalculoDeNomina,
  recalcularNomina,
  recalcularNominaEmpleados,
  postValidarLayoutAnticipoAguinaldo,
  getTaskStatus,
  getEstadoBloqueoEntidad,
} from 'api/nominas/calculosDeNominaEncabezado';
import {
  descargarExcel, descargarPDF, descargarZIP, getNominasPlazas, descargarResumenNomina, descargarRelacionRecibo, descargarListadoRetencionDePago,
} from 'api/nominas/calculosDeNominas';
import descargarPDFGeneral from 'components/PDF/descargarPDFGeneral';
import { checkToken } from 'api/utils';
import { readPersistedTableQuery } from 'utils/tableFiltersStorage';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTADO_SUSPENDIDO,
  NOMINA_ORDINARIA,
  NOMINA_EXTRAORDINARIA,
  SUBTIPO_NOMINA_EXTEMPORANEO,
  SUBTIPO_NOMINA_NINGUNO,
  SUBTIPO_NOMINA_ANTICIPO_AGUINALDO,
} from 'utils/constants';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import moment from 'moment';
import 'moment/locale/es';
import { getModelPermission } from 'utils/permission';
import { getNominasOrigenesRecursos } from 'api/nominas/nominasOrigenesRecursos';
import { getOrigenesRecursosNominas } from 'api/catalogos/origenesRecursosNominas';
import { getSubtiposNominas } from 'api/nominas/subtiposDeNominas';
import { getCalculoFuentesFinanciamiento } from 'api/catalogos/calculoFuenteFinanciamiento';
import ReportViewer from 'components/ReportViewer';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import TITULOS_COLUMNAS_NOMINA from 'utils/titulosExportacionNomina';
import CalculoDeNomina, { calculoDeNominaPermission } from './CalculoDeNominas';
import CalculoFuentesFinanciamiento from './CalculoFuentesFinanciamiento';

const { Text } = Typography;
const { TabPane } = Tabs;

// Mitigación de "Formula/CSV Injection" para celdas armadas a mano con aoa_to_sheet
// (mismo criterio que components/ExportadorExcelPersonalizado.jsx).
const CARACTERES_DE_FORMULA = ['=', '+', '-', '@', '\t', '\r'];
const sanitizarCeldaExcel = (valor) => {
  if (typeof valor !== 'string' || valor.length === 0) return valor;
  return CARACTERES_DE_FORMULA.includes(valor.charAt(0)) ? `'${valor}` : valor;
};

export const calculosDeNominaEncabezadoPermission = {
  permissionModel: 'nomina',
  catalogsModels: [],
  tabsModels: [],
};

// ==========================================
// VISOR DE RESUMEN (DevExpress ReportViewer, sin panel de parámetros)
// ==========================================
// Reporte 2003 ("Resumen de Nómina"): totales de Percepciones/Deducciones/Descuentos y pagos
// por Nómina — no depende de la distribución por Fuente de Financiamiento (ver
// nominas/views/resumen_nomina_descargar.py en SAC), así que a diferencia de
// NominaPolizaViewer no necesita verificar Fuentes de Financiamiento pendientes de revisión.
const NominaResumenViewer = ({ nominaId, isVisible }) => {
  if (!isVisible || !nominaId) {
    return null;
  }

  return (
    <ReportViewer
      reportId={2003}
      parameters={{ nomina: nominaId }}
      hideParametersPanel
      height="70vh"
    />
  );
};

// ==========================================
// VISOR DE PÓLIZA (DevExpress ReportViewer, sin panel de parámetros)
// ==========================================
// Mismo reporte 2002 ("Mapeo Poliza Nomina", OID=34) que usaba NominaPdfViewer, pero con el
// visor oficial DevExpress en vez del iframe legacy de postObtenerReporte. El parametro
// "nomina" se precarga y se envia solo (el usuario nunca ve el panel de parametros, porque
// la Nomina ya esta fija por el tab seleccionado). Conserva el mismo chequeo de Fuentes de
// Financiamiento pendientes de revision que ya tenia el visor anterior.
const NominaPolizaViewer = ({ nominaId, isVisible }) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [fuentesPendientesDeRevision, setFuentesPendientesDeRevision] = useState(false);

  useEffect(() => {
    const verificar = async () => {
      setLoading(true);
      const pendientes = await getCalculoFuentesFinanciamiento({
        nomina: nominaId,
        requiere_revision: true,
      });
      setFuentesPendientesDeRevision(!!pendientes?.length);
      setLoading(false);
      setChecked(true);
    };
    if (isVisible && nominaId && !checked) {
      verificar();
    }
    // eslint-disable-next-line
  }, [isVisible, nominaId]);

  if (loading) {
    return <Spin spinning tip="Verificando Fuentes de Financiamiento..." />;
  }

  if (fuentesPendientesDeRevision) {
    return (
      <Alert
        type="warning"
        showIcon
        message="Hay Fuentes de Financiamiento pendientes de revisión"
        description={'El importe de una o más Percepciones repartidas entre varias Fuentes de '
          + 'Financiamiento cambió al recalcular esta Nómina. Revísalas en el tab '
          + '"F. Financiamiento" antes de consultar la Póliza.'}
      />
    );
  }

  if (!checked) {
    return null;
  }

  return (
    <ReportViewer
      reportId={2002}
      parameters={{ nomina: nominaId }}
      hideParametersPanel
      height="70vh"
    />
  );
};

// ==========================================
// MODAL EXCEL NUEVO - CON PERIODO FISCAL Y PERIODO CONCATENADO
// ==========================================
const ModalNuevoExcel = ({
  visible,
  onCancel,
  onConfirm,
  title = 'Reporte de Nóminas',
  confirmText = 'Generar Excel Unificado',
}) => {
  const [selectedNominas, setSelectedNominas] = useState([]);
  const [periodoFiscal, setPeriodoFiscal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nominasOptions, setNominasOptions] = useState([]);
  const [periodosFiscalesOptions, setPeriodosFiscalesOptions] = useState([]);
  const [allNominas, setAllNominas] = useState([]);

  useEffect(() => {
    if (visible) {
      const loadOptions = async () => {
        setLoading(true);
        try {
          const nominasResponse = await API.get('/nominas/nominas-vista-optimized/');
          const nominasArray = nominasResponse.data?.results || nominasResponse.data || [];
          setAllNominas(nominasArray);

          const pfData = await getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO });
          const pfArray = Array.isArray(pfData) ? pfData : (pfData?.results || []);
          setPeriodosFiscalesOptions(
            pfArray.map((p) => ({
              label: p.periodo || p.nombre || `PF ${p.id}`,
              value: p.id,
            })),
          );

          updateNominasOptions(nominasArray, null);
        } catch (err) {
          message.error('Error al cargar las opciones del modal');
        } finally {
          setLoading(false);
        }
      };
      loadOptions();
    }
  }, [visible]);

  const updateNominasOptions = (nominasArray, pfId) => {
    let filteredNominas = nominasArray;
    if (pfId) {
      filteredNominas = nominasArray.filter((n) => n.periodo_fiscal_id === pfId);
    }

    const options = filteredNominas.map((n) => ({
      label: `${n.numero_nomina || 'Sin número'} - ${n.tipo_de_nomina_descripcion || 'Nómina'} (${moment(n.fecha_de_calculo).format('DD/MM/YYYY')}) - ${n.tipo_de_nomina_empleado_descripcion || ''}`,
      value: n.id,
      numeroNomina: n.numero_nomina,
      tipoNominaDesc: n.tipo_de_nomina_descripcion,
      fechaCalculo: n.fecha_de_calculo,
      tipoEmpleadoDesc: n.tipo_de_nomina_empleado_descripcion,
      periodoFiscalId: n.periodo_fiscal_id,
      periodoDetalleId: n.periodo_de_nomina_detalle_id,
    }));

    setNominasOptions(options);
  };

  const handlePeriodoFiscalChange = (value) => {
    setPeriodoFiscal(value);
    setSelectedNominas([]);
    updateNominasOptions(allNominas, value);
  };

  const handleExport = () => {
    if (selectedNominas.length === 0) {
      message.warning('Debe seleccionar al menos una nómina');
      return;
    }
    if (!periodoFiscal) {
      message.warning('Debe seleccionar un Periodo Fiscal');
      return;
    }

    const selectedOptions = nominasOptions.filter((opt) => selectedNominas.includes(opt.value));

    onConfirm({
      nominas: selectedNominas,
      periodoFiscal,
      nominasData: selectedOptions,
    });
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      width={900}
      footer={[
        <Button key="cancel" onClick={onCancel} className="default">
          Cancelar
        </Button>,
        <Button
          key="export"
          onClick={handleExport}
          loading={loading}
          icon={<FileExcelOutlined />}
          className="default"
        >
          {confirmText}
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form layout="vertical">
          <Form.Item label="Periodo Fiscal" required>
            <AntSelect
              placeholder="Seleccione periodo fiscal"
              value={periodoFiscal}
              onChange={handlePeriodoFiscalChange}
              options={periodosFiscalesOptions}
              showSearch
              filterOption={(input, option) => (option?.label?.toLowerCase() || '').includes(input.toLowerCase())}
              notFoundContent={loading ? 'Cargando...' : 'No hay periodos fiscales disponibles'}
            />
          </Form.Item>

          <Form.Item
            label="Nóminas a incluir"
            required
            help="Seleccione una o más nóminas del periodo fiscal seleccionado"
          >
            <AntSelect
              mode="multiple"
              placeholder={periodoFiscal ? 'Seleccione una o más nóminas' : 'Primero seleccione un periodo fiscal'}
              value={selectedNominas}
              onChange={setSelectedNominas}
              options={nominasOptions}
              style={{ width: '100%' }}
              showSearch
              disabled={!periodoFiscal}
              filterOption={(input, option) => (option?.label?.toLowerCase() || '').includes(input.toLowerCase())}
              notFoundContent={loading ? 'Cargando...' : periodoFiscal ? 'No hay nóminas para este periodo fiscal' : 'Seleccione un periodo fiscal primero'}
              maxTagCount="responsive"
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

// Id fijo de la tabla principal: todos los tabs comparten la misma búsqueda ("calculo-nominas").
const TABLE_STORAGE_ID = 'calculo-nominas';
// Búsqueda capturada en cualquier tab (se incluye al pedir los datos de otro tab o al recargar).
const busquedaGuardada = () => readPersistedTableQuery(window.location.pathname, {
  storageId: TABLE_STORAGE_ID,
});

const CalculosDeNominaEncabezado = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // Excel Personalizado (mismo exportador que el detalle de la nómina)
  const [showExportadorPersonalizado, setShowExportadorPersonalizado] = useState(false);
  const [datosExportadorPersonalizado, setDatosExportadorPersonalizado] = useState([]);
  const [folioExportadorPersonalizado, setFolioExportadorPersonalizado] = useState('');
  const [encabezado, setEncabezado] = useState();
  const [loading, setLoading] = useState(false);
  const [calculando, setCalculando] = useState(false);
  const [loadingRecalcular, setLoadingRecalcular] = useState(false);
  const [visibleGuardarYRecalcular, setVisibleGuardarYRecalcular] = useState(false);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposNominas, setTiposNominas] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [periodo, setPeriodo] = useState();
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosFiltered, setPeriodosFiltered] = useState([]);
  const [visibleConfirmAuthorize, setVisibleConfirmAuthorize] = useState(false);
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleErrores, setVisibleErrores] = useState(false);
  const [errores, setErrores] = useState([]);
  const [renderizado, setRenderizado] = useState(false);
  const [origenesRecursosSAT, setOrigenesRecursosSAT] = useState([]);
  const [nominasOrigenesRecursos, setNominasOrigenesRecursos] = useState([]);
  const [subtiposDeNomina, setSubtiposDeNomina] = useState([]);
  const [subtiposFiltered, setSubtiposFiltered] = useState([]);
  const [disableSubtipo, setDisableSubtipo] = useState(true);
  const entidad = useSelector(seelectEntidad);
  const titleTable = 'Cálculo de Nómina';
  const [isPolling, setIsPolling] = useState(false);
  const [nominaList, setNominaList] = useState([]);
  const [nominaEnProcesoId, setNominaEnProcesoId] = useState(null);
  // Polling del task_id que regresa Autorizar/Cancelar (descuentos_saldo_task_id):
  // mientras esta tarea no termine, el periodo de esa nomina sigue bloqueado para
  // Calcular/Autorizar/Cancelar (ver nominas/utils/bloqueo_periodo_nomina.py).
  const [saldoTaskId, setSaldoTaskId] = useState(null);
  const [saldoTaskAccion, setSaldoTaskAccion] = useState(null);
  // Candado a nivel entidad (nominas/utils/bloqueo_periodo_nomina.py): true mientras
  // haya un Calculo/Autorizacion/Cancelacion en curso para CUALQUIER periodo de la
  // entidad -el saldo de los descuentos con control de saldo es de la entidad, no
  // del periodo, asi que un Autorizar de otro periodo tambien bloquea. Se consulta
  // por polling (no solo cuando esta sesion dispara la accion) porque el proceso
  // pudo iniciarlo otro usuario/pestaña.
  const [bloqueoEntidadEnCurso, setBloqueoEntidadEnCurso] = useState(false);
  const [pageActual, setPageActual] = useState(1);
  const [activeTabNomina, setActiveTabNomina] = useState('detalle');
  // Fuerza el remount (y por lo tanto el refetch) de los tabs F. Financiamiento/Resumen/Pólizas
  // cuando termina un cálculo -- esos tabs solo cargan sus datos una vez al montarse.
  const [refreshKeyPostCalculo, setRefreshKeyPostCalculo] = useState(0);
  const [aplicaRetroactivo, setAplicaRetroactivo] = useState(false);
  const [showNuevoExcelModal, setShowNuevoExcelModal] = useState(false);
  // Reporte de Nóminas: datos preparados para el Exportador Personalizado agrupado por Departamento
  const [showExportadorReporteNominas, setShowExportadorReporteNominas] = useState(false);
  const [reporteNominas, setReporteNominas] = useState(null);
  const [showRetenidosModal, setShowRetenidosModal] = useState(false);
  const [bancos, setBancos] = useState([]);
  const [aplicaCalculoPorEmpleado, setAplicaCalculoPorEmpleado] = useState(false);
  const [aplicaRetroactivoPorEmpleado, setAplicaRetroactivoPorEmpleado] = useState(false);
  const [empleadosDisponibles, setEmpleadosDisponibles] = useState([]);
  const [loadingEmpleados, setLoadingEmpleados] = useState(false);
  // La pantalla abre en "Todos" (primer tab).
  const [tabListaActiva, setTabListaActiva] = useState('todos');
  const tabListaActivaRef = useRef('todos');
  // true cuando el formulario se abrió con "Editar" (en vez de "Detalle"): solo cambia el título.
  const [abiertoParaEditar, setAbiertoParaEditar] = useState(false);
  const [anticiposAguinaldoRegistros, setAnticiposAguinaldoRegistros] = useState([]);
  const [uploadingAnticipoAguinaldo, setUploadingAnticipoAguinaldo] = useState(false);
  const [layoutAnticipoAguinaldoErrorBase64, setLayoutAnticipoAguinaldoErrorBase64] = useState(null);
  const [modoCargaAnticipoAguinaldo, setModoCargaAnticipoAguinaldo] = useState('agregar');
  // Contador compartido por las 3 rutas que llenan `data` desde la API (carga inicial,
  // cambio de tab, paginacion): si el usuario cambia de tab (p.ej. a "Activas") antes de
  // que termine una peticion anterior mas lenta y sin filtro (p.ej. el fetchAll inicial de
  // "Todos", que espera un Promise.all grande), esa respuesta tardia llegaba de todas
  // formas y pisaba el resultado ya filtrado con la lista completa -- bug intermitente
  // reportado por el usuario. Cada fetch toma el siguiente numero antes de pedir datos y
  // solo aplica su resultado si sigue siendo el mas reciente al resolver.
  const dataRequestSeqRef = useRef(0);

  const tipoDeNominaWatch = Form.useWatch('tipo_de_nomina', form);
  const subtipoDeNominaWatch = Form.useWatch('subtipo_de_nomina', form);
  const tipoDeNominaEmpleadoWatch = Form.useWatch('tipo_de_nomina_empleado', form);
  const esAnticipoAguinaldo = tipoDeNominaWatch === NOMINA_EXTRAORDINARIA
    && subtipoDeNominaWatch === SUBTIPO_NOMINA_ANTICIPO_AGUINALDO;

  const tipoNominaEmpleadoActual = tiposNominasEmpleados.find((e) => e.id === tipoDeNominaEmpleadoWatch);
  const sujetoLabels = getSujetoDeNominaLabels(tipoNominaEmpleadoActual?.content_type_model);

  useEffect(() => {
    if (!esAnticipoAguinaldo) {
      setAnticiposAguinaldoRegistros([]);
      setLayoutAnticipoAguinaldoErrorBase64(null);
      setModoCargaAnticipoAguinaldo('agregar');
    }
  }, [esAnticipoAguinaldo]);

  // `todos: null` -> no se envía `estados_globales` y el API regresa Activas,
  // Autorizadas y Canceladas en una sola petición (el filtro es opcional en NominaFilterSet).
  const TAB_ESTADOS_NOMINA = {
    todos: null, activas: 1, autorizadas: 4, canceladas: 5,
  };
  const paramsEstado = (tabKey) => {
    const estado = TAB_ESTADOS_NOMINA[tabKey];
    return estado ? { estados_globales: estado } : {};
  };

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        tipo_de_nomina_empleado_periodicidad: e?.tipo_de_nomina_empleado,
        fecha_final_nomina_mes: e?.fecha_final_nomina,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const getPermission = getModelPermission(
    calculoDeNominaPermission.permissionModel,
    calculoDeNominaPermission.catalogsModels,
    calculoDeNominaPermission.tabsModels,
    false,
  );

  const formInstances = [form];
  const baseURI = 'nominas/nominas';

  // Recibe la key del tab (no el estado) para que "Todos" (estado null) no caiga en el
  // estado del tab anterior. El default lee de la ref (siempre actual) en vez del state
  // (que puede ser stale en closures de callbacks async o setInterval).
  const fetchData = async (page = 1, q = null, tabKey = tabListaActivaRef.current) => {
    dataRequestSeqRef.current += 1;
    const seq = dataRequestSeqRef.current;
    setLoading(true);
    const _data = await API.get(baseURI, {
      params: { page, ...paramsEstado(tabKey), ...(q ?? busquedaGuardada()) },
    });
    const results = formatReceivedClone(_data.data.results);
    if (dataRequestSeqRef.current === seq) {
      setData({ ..._data.data, results });
      setLoading(false);
    }
  };

  const fetchPaginated = async (page = 1, q = null) => {
    dataRequestSeqRef.current += 1;
    const seq = dataRequestSeqRef.current;
    try {
      setLoading(true);
      const response = await API.get(baseURI, { params: { page, ...paramsEstado(tabListaActivaRef.current), ...q } });
      const results = formatReceivedClone(response.data.results);
      if (dataRequestSeqRef.current === seq) {
        setSelectedRowKeys([]);
        setPageActual(page);
        setData({ ...response.data, results });
        setLoading(false);
      }
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    let mounted = true;
    dataRequestSeqRef.current += 1;
    const seq = dataRequestSeqRef.current;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tiposNominas,
        _tiposNominasEmpleados,
        _periodicidades,
        _periodosNominasDetalles,
        _periodosFiscales,
        _periodosNominas,
        _origen_del_recurso_sat,
        _subtiposDeNomina,
        _data,
        _bancos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeNomina(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getOrigenesRecursosNominas(),
        getSubtiposNominas(),
        // Carga inicial del tab "Todos": sin filtro de estatus.
        getCalculosDeNominas({}),
        getBancos(),
      ]);
      const rawResults = Array.isArray(_data?.results) ? _data.results : [];
      const results = formatReceivedClone(rawResults);
      if (mounted) {
        setEstados(_estados);
        setTiposNominas(_tiposNominas);
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setPeriodicidades(_periodicidades);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setPeriodosFiscales(_periodosFiscales);
        setPeriodosNominas(_periodosNominas);
        setOrigenesRecursosSAT(_origen_del_recurso_sat);
        setSubtiposDeNomina(_subtiposDeNomina);
        setSubtiposFiltered(_subtiposDeNomina);
        setBancos(Array.isArray(_bancos) ? _bancos : (_bancos?.results || []));
        // Esta carga inicial siempre pide "Todos" (sin filtro) y puede tardar mas que un
        // cambio de tab que el usuario haga mientras tanto (ver dataRequestSeqRef arriba) --
        // si ya se disparo un fetch mas reciente (p.ej. al tab "Activas"), no pisar su
        // resultado ya filtrado con esta lista completa.
        if (dataRequestSeqRef.current === seq) {
          setData({ ..._data, results });
          setLoading(false);
        }
      }
    };
    fetchAll();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line
  }, []);

  // UseEffect para el manejo de la conexion por sockets
  // useEffect(() => {
  //   let chatSocket;
  //   if (renderizado) {
  //     const [key] = selectedRowKeys;
  //     const match = data.find((item) => item.id === key);
  //     chatSocket = new WebSocket(`wss://${API_HOST}/ws/nomina/${match.id}/`);
  //     setTimeout(() => {
  //       if (chatSocket.readyState === 1) {
  //         chatSocket.send(JSON.stringify({
  //           type: 'message',
  //           message: match.id,
  //           name: match.id,
  //         }));
  //       }
  //     }, 500);
  //     chatSocket.onmessage = (message) => {
  //       const dataFromserver = JSON.parse(message.data);
  //       if (dataFromserver.message) {
  //         setCalculando(false);
  //         setRenderizado(false);
  //         // eslint-disable-next-line no-use-before-define
  //         onClickEdit();
  //         fetchData();
  //       }
  //     };
  //   }
  //   return () => {
  //     if (chatSocket) {
  //       chatSocket.close();
  //     }
  //   };
  // });
  // referencia mutable para guardar el id del interval (no provoca re-render)
  const pollingRef = useRef(null);
  // Nomina para la que ya se aplico el refresco post-calculo (ver onCalculoTerminado).
  // Se reinicia a null en cada punto donde arranca un calculo/recalculo nuevo.
  const refrescoAplicadoNominaIdRef = useRef(null);

  // callback invocado tanto por CalculoDeNomina (su propio polling de
  // progreso-calculo) como por el polling de este componente más abajo
  // (nomina_calculada): ambos detectan el fin del cálculo de forma
  // independiente y es una carrera cuál de los dos llega primero -- si solo
  // uno de los dos disparaba el remount de F. Financiamiento/Resumen/Pólizas,
  // la tabla se quedaba con los datos viejos cuando ganaba el otro.
  // IMPORTANTE: si ambos detectores llegan a disparar (uno como respaldo del otro, no
  // excluyentes entre si), sin el guard de abajo esto remonta el visor DevExpress de
  // Resumen/Polizas DOS veces seguidas para el mismo cálculo -- confirmado en logs de
  // reporteador-reporteador-1 (2026-10-19) como la causa de que, ademas de la condicion de
  // carrera transitoria de un solo remount (ya mitigada en ReportViewer con un reintento),
  // dos remounts solapados del mismo reportUrl corrompan el estado del visor con
  // ObjectDisposedException ("AsyncLocker") cuando el primero libera su reporte justo
  // mientras el segundo todavia esta sondeando el build en curso.
  const onCalculoTerminado = async (nominaId) => {
    if (refrescoAplicadoNominaIdRef.current === nominaId) {
      return;
    }
    refrescoAplicadoNominaIdRef.current = nominaId;
    try {
      const _errores = await getNominasErrores({ nomina: nominaId });
      setErrores(_errores || []);
    } catch (error) {
      onError(error);
    }
    setRefreshKeyPostCalculo((key) => key + 1);
  };

  useEffect(() => {
  // función auxiliar que refresca los datos de la nómina seleccionada
    const refreshNominaSeleccionada = async (id) => {
    // obtiene el cálculo de la nómina por id desde el backend
      const _calculo = await getCalculoDeNomina(id);
      // obtiene los orígenes de recurso asociados a la nómina
      const _origenesDeRecurso = await getNominasOrigenesRecursos({ nomina: id });

      // actualiza el estado del encabezado con el cálculo formateado
      setEncabezado(formatReceivedClone(_calculo));
      // actualiza el estado con los orígenes de recurso obtenidos
      setNominasOrigenesRecursos(_origenesDeRecurso);
      // indica que ya no está en estado "calculando"
      setCalculando(false);
    };

    // si está activado el polling y hay una nómina en proceso (id definida)
    if (isPolling && nominaEnProcesoId) {
    // guarda en la ref el id del setInterval para poder limpiarlo después
      pollingRef.current = setInterval(async () => {
        try {
          // consulta directamente la nómina en proceso por su id
          const nominaActual = await getCalculoDeNomina(nominaEnProcesoId);

          // nomina_calculada:true indica que el cálculo finalizó
          if (nominaActual?.nomina_calculada) {
          // limpia el intervalo (deja de hacer polling)
            clearInterval(pollingRef.current);
            // resetea la ref para indicar que no hay intervalo activo
            pollingRef.current = null;
            // actualiza estados para detener el polling
            setIsPolling(false);
            setNominaEnProcesoId(null);

            // muestra una notificación de éxito al usuario
            notification.success({
              message: 'Cálculo completado',
              description: `La nómina ${nominaActual.numero_nomina} ha finalizado su cálculo.`,
              placement: 'topRight',
              duration: 0, // duración 0 => la notificación permanece hasta que el usuario la cierre
            });

            // refresca los detalles de la nómina seleccionada (carga datos actualizados)
            await refreshNominaSeleccionada(nominaActual.id);

            // actualiza errores (para que "Historial de Errores" aparezca al instante) y
            // fuerza el remount de F. Financiamiento/Resumen/Pólizas -- mismo efecto que
            // onCalculoTerminado, por si este polling detecta el fin del cálculo antes que
            // el de CalculoDeNomina (ver comentario en la declaración de onCalculoTerminado).
            await onCalculoTerminado(nominaActual.id);
          }
        } catch (error) {
          // No se interrumpe el polling por un error puntual (red, 5xx, etc.):
          // el siguiente tick reintenta. Si el error es por token/sesión
          // expirada, el interceptor de utils/api.js ya avisó al usuario y
          // cerró la sesión; aquí solo dejamos rastro para diagnóstico.
          // eslint-disable-next-line no-console
          console.error('[polling cálculo de nómina] error al consultar estado', error);
        }
      }, 5000); // intervalo de 5 segundos entre cada comprobación
    }

    // cleanup del useEffect: se ejecuta cuando se desmonta el componente o cambian deps
    return () => {
    // si hay un intervalo activo, lo limpia para evitar fugas y ejecuciones en componentes desmontados
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  // dependencias: el efecto se vuelve a ejecutar cuando cambian isPolling o nominaEnProcesoId
  }, [isPolling, nominaEnProcesoId]);

  // referencia mutable para el interval del polling de saldoTaskId (no provoca re-render)
  const saldoTaskPollingRef = useRef(null);

  // Polling de descuentos_saldo_task_id: mientras Autorizar/Cancelar sigue afectando
  // en segundo plano el saldo de los descuentos con control de saldo, el periodo de
  // esta nomina queda bloqueado para un nuevo Calcular/Autorizar/Cancelar. Este efecto
  // avisa al usuario en cuanto esa tarea realmente termina (mismo patron de polling
  // que ya usa el calculo de nomina arriba, cada 5s).
  useEffect(() => {
    if (saldoTaskId) {
      saldoTaskPollingRef.current = setInterval(async () => {
        try {
          const estado = await getTaskStatus(saldoTaskId);
          if (estado?.ready) {
            clearInterval(saldoTaskPollingRef.current);
            saldoTaskPollingRef.current = null;
            setSaldoTaskId(null);
            if (estado.exitoso === false) {
              notification.warning({
                message: 'Revisa el Historial de Errores',
                description: `${saldoTaskAccion === 'cancelar' ? 'La cancelación' : 'La autorización'} se completó, pero ocurrió un problema al afectar el saldo de los descuentos. Revisa el Historial de Errores de la nómina.`,
                placement: 'topRight',
                duration: 0,
              });
            } else {
              notification.success({
                message: 'Listo',
                description: 'Ya se actualizó el saldo de los descuentos de esta nómina. Puedes calcular, autorizar o cancelar otra nómina de este mismo periodo.',
                placement: 'topRight',
                duration: 0,
              });
            }
            setSaldoTaskAccion(null);
          }
        } catch (error) {
          // No se interrumpe el polling: el siguiente tick reintenta. Si el
          // error es por sesión expirada, utils/api.js ya avisó y cerró
          // sesión; aquí solo dejamos rastro para diagnóstico.
          // eslint-disable-next-line no-console
          console.error('[polling saldo de descuentos] error al consultar estado', error);
        }
      }, 5000);
    }
    return () => {
      if (saldoTaskPollingRef.current) {
        clearInterval(saldoTaskPollingRef.current);
        saldoTaskPollingRef.current = null;
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saldoTaskId]);

  // Polling del candado de entidad (estado-bloqueo): corre siempre mientras el
  // componente esta montado, sin importar si esta sesion disparo un Autorizar/
  // Cancelar o no -otra pestaña/usuario pudo haberlo iniciado. Deshabilita Calcular/
  // Autorizar/Cancelar y muestra el indicador mientras dure.
  useEffect(() => {
    let mounted = true;
    const consultarBloqueo = async () => {
      const estado = await getEstadoBloqueoEntidad();
      if (mounted && estado) {
        setBloqueoEntidadEnCurso(!!estado.en_curso);
      }
    };
    consultarBloqueo();
    const intervalId = setInterval(consultarBloqueo, 5000);
    return () => {
      mounted = false;
      clearInterval(intervalId);
    };
  }, []);

  // Verificacion inmediata (sin esperar el proximo tick del polling de 5s) justo al
  // abrir el formulario de Agregar o los modales de confirmacion de Autorizar/
  // Cancelar. El polling de arriba puede tardar hasta 5s en detectar que otro
  // usuario/pestaña acaba de iniciar un Calculo/Autorizacion/Cancelacion; este efecto
  // consulta el estado en el instante en que esta sesion intenta la misma accion, para
  // que dos personas no alcancen a calcular/autorizar/cancelar al mismo tiempo.
  useEffect(() => {
    const hayAccionAbierta = visibleConfirmAuthorize || visibleCancelar || (open && !selectedRowKeys.length);
    if (!hayAccionAbierta) {
      return undefined;
    }
    let mounted = true;
    (async () => {
      const estado = await getEstadoBloqueoEntidad();
      if (!mounted || !estado?.en_curso) {
        return;
      }
      setBloqueoEntidadEnCurso(true);
      if (visibleConfirmAuthorize) {
        setVisibleConfirmAuthorize(false);
      }
      if (visibleCancelar) {
        setVisibleCancelar(false);
      }
      if (open && !selectedRowKeys.length) {
        onCancel();
      }
      notification.warning({
        message: 'Proceso en curso',
        description: 'Hay un proceso de Cálculo, Autorización o Cancelación de nómina en curso. Espera a que termine.',
        placement: 'topRight',
      });
    })();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleConfirmAuthorize, visibleCancelar, open]);

  const onGuardarYRecalcular = () => {
    if (esAnticipoAguinaldo) {
      // Cargar un nuevo layout es opcional: tambien se puede recalcular sin cambios,
      // reusando los registros de Anticipo de Aguinaldo ya guardados en la nomina.
      setVisibleGuardarYRecalcular(true);
      return;
    }
    const aplica = form.getFieldValue('aplica_calculo_por_empleado');
    const empleados = form.getFieldValue('empleados_a_calcular') || [];
    if (aplica && !empleados.length) {
      notification.warning({
        message: 'Validación',
        description: 'Selecciona al menos un empleado para calcular.',
        placement: 'topRight',
      });
      return;
    }
    const aplicaRetroPorEmpleado = form.getFieldValue('aplica_calculo_retroactivo_por_empleado');
    const empleadosRetro = form.getFieldValue('empleados_a_calcular_retroactivo') || [];
    if (aplicaRetroPorEmpleado && !empleadosRetro.length) {
      notification.warning({
        message: 'Validación',
        description: 'Selecciona al menos un empleado para el cálculo retroactivo.',
        placement: 'topRight',
      });
      return;
    }
    setVisibleGuardarYRecalcular(true);
  };

  const onConfirmGuardarYRecalcular = async () => {
    try {
      setLoadingRecalcular(true);
      setVisibleGuardarYRecalcular(false);

      // Anticipo de Aguinaldo: cargar un nuevo layout es opcional. Si se cargo uno en esta
      // sesion se envia (el backend lo aplica segun el modo elegido); si no, simplemente se
      // recalcula reusando los registros de Anticipo de Aguinaldo ya guardados en la nomina.
      const hayNuevoLayoutAnticipoAguinaldo = esAnticipoAguinaldo && anticiposAguinaldoRegistros.length > 0;

      let patchPayload = null;
      if (hayNuevoLayoutAnticipoAguinaldo) {
        patchPayload = {
          anticipos_aguinaldo: JSON.stringify(anticiposAguinaldoRegistros),
          modo_carga_anticipo_aguinaldo: modoCargaAnticipoAguinaldo,
        };
      } else if (!esAnticipoAguinaldo) {
        const aplica = form.getFieldValue('aplica_calculo_por_empleado');
        const empleados = form.getFieldValue('empleados_a_calcular') || [];
        const aplicaRetroPorEmpleado = form.getFieldValue('aplica_calculo_retroactivo_por_empleado');
        const empleadosRetro = form.getFieldValue('empleados_a_calcular_retroactivo') || [];
        patchPayload = {
          aplica_calculo_por_empleado: aplica,
          empleados_a_calcular: aplica ? empleados.map(Number) : [],
          aplica_calculo_retroactivo_por_empleado: aplicaRetroPorEmpleado,
          empleados_a_calcular_retroactivo: aplicaRetroPorEmpleado ? empleadosRetro.map(Number) : [],
        };
      }

      if (patchPayload) {
        const updated = await patchCalculoDeNomina(encabezado.id, patchPayload);
        if (!updated) {
          setLoadingRecalcular(false);
          return;
        }

        setEncabezado((prev) => ({
          ...prev,
          ...(esAnticipoAguinaldo ? {} : {
            aplica_calculo_por_empleado: patchPayload.aplica_calculo_por_empleado,
            empleados_a_calcular: patchPayload.empleados_a_calcular,
            aplica_calculo_retroactivo_por_empleado: patchPayload.aplica_calculo_retroactivo_por_empleado,
            empleados_a_calcular_retroactivo: patchPayload.empleados_a_calcular_retroactivo,
          }),
          fecha_final_calculos: null,
        }));
      } else {
        setEncabezado((prev) => ({ ...prev, fecha_final_calculos: null }));
      }
      // Arranca un recalculo nuevo para esta Nomina: rearma el guard de onCalculoTerminado
      // para que su fin vuelva a disparar el refresco (ver comentario en su declaracion).
      refrescoAplicadoNominaIdRef.current = null;
      setCalculando(true);

      const res = (esAnticipoAguinaldo || form.getFieldValue('aplica_calculo_por_empleado'))
        ? await recalcularNominaEmpleados(encabezado.id)
        : await recalcularNomina(encabezado.id);

      if (res) {
        // el backend ya hizo soft-delete del historial de errores previo al
        // iniciar el recálculo (limpiar_datos_nomina); se limpia aquí también
        // para que el aviso "Ha ocurrido un error" no siga mostrando errores
        // ya inexistentes mientras dura el nuevo cálculo
        // NOTA: no se usa isPolling/nominaEnProcesoId aquí porque ese mecanismo
        // depende del campo nomina_calculada, que en un recálculo puede seguir
        // en true (valor del cálculo anterior) hasta que el backend lo resetea,
        // provocando que se reporte "completado" antes de que progreso-calculo
        // indique terminado=true. El refresco real de errores ocurre en
        // onCalculoTerminado, disparado por CalculoDeNomina cuando progreso.terminado
        // es true (fuente de verdad real del avance).
        setErrores([]);
        notification.info({
          message: 'Recálculo iniciado',
          description: res.mensaje || 'El recálculo ha sido iniciado.',
          placement: 'topRight',
          duration: 6,
        });
      }
      setLoadingRecalcular(false);
    } catch (err) {
      onError(err);
      setLoadingRecalcular(false);
    }
  };

  const onCancel = () => {
    setAbiertoParaEditar(false);
    setSelectedRowKeys([]);
    setEncabezado();
    setVisible(false);
    setPeriodo();
    setErrores([]);
    setRenderizado(false);
    setAplicaRetroactivo(false);
    setPeriodosFiltered([]);
    setCalculando(false);
    setDisableSubtipo(true);
    setAplicaCalculoPorEmpleado(false);
    setEmpleadosDisponibles([]);
    form.resetFields();
  };

  const filterPeriodos = (_data) => {
    const {
      tipo_de_nomina_empleado,
      periodo_fiscal,
    } = form.getFieldsValue();

    const _periodo = periodo_fiscal || _data?.periodo_fiscal;
    const _tipo_nomina = tipo_de_nomina_empleado || _data?.tipo_de_nomina_empleado;

    const _periodosNominas = periodosNominas.filter(
      (e) => e.tipo_de_nomina_empleado === _tipo_nomina && e.periodo_fiscal === _periodo,
    );

    const _periodosDetallesFiltered = periodosNominasDetalles.filter(
      (e) => _periodosNominas.some(((x) => x.id === e.periodo_de_nomina)),
    );

    setPeriodosFiltered(_periodosDetallesFiltered);
  };

  const NUMERO_FIELD_POR_SUJETO = {
    empleado: 'numero_de_empleado',
    becario: 'numero_de_becario',
    honorarioasimilado: 'numero_de_honorario_asimilado',
  };

  const fetchEmpleadosPorTipoNomina = async (tipoNominaEmpleadoId) => {
    if (!tipoNominaEmpleadoId) {
      setEmpleadosDisponibles([]);
      return;
    }
    setLoadingEmpleados(true);
    const nomina = tiposNominasEmpleados.find((e) => e.id === tipoNominaEmpleadoId);
    const sujeto = nomina?.content_type_model || 'empleado';
    // Por ningún motivo un empleado/becario/honorario Suspendido debe quedar disponible
    // para ser incluido en un cálculo de nómina (ver historial_movimientos de la nomina 00589,
    // empleado 6794: una incapacidad activa no detuvo el pago porque nunca hubo una
    // Suspensión de Pago asociada). Se excluye ESTADO_SUSPENDIDO de este listado para que
    // nunca pueda seleccionarse manualmente desde esta pantalla.
    const estadosElegiblesParaCalculo = [2, 6, 3, 5].filter((estado) => estado !== ESTADO_SUSPENDIDO);
    let results;
    if (sujeto === 'becario') {
      results = await getBecariosWithoutFilter({ estado_del_becario: estadosElegiblesParaCalculo });
    } else if (sujeto === 'honorarioasimilado') {
      results = await getHonorariosAsimiladosWithoutFilter({ estado_del_honorario_asimilado: estadosElegiblesParaCalculo });
    } else {
      results = await getEmpleadosWithoutFilter({ estado_del_empleado: estadosElegiblesParaCalculo });
    }
    const all = Array.isArray(results) ? results : (results?.results || []);
    const numeroField = NUMERO_FIELD_POR_SUJETO[sujeto] || 'numero_de_empleado';
    setEmpleadosDisponibles(all.sort((a, b) => Number(a[numeroField]) - Number(b[numeroField])));
    setLoadingEmpleados(false);
  };

  const filterSubtipos = (value) => {
    let _filteredSubtipos;

    if (value) {
      setDisableSubtipo(false);
    } else {
      setDisableSubtipo(true);
    }

    if (value === NOMINA_ORDINARIA) {
      _filteredSubtipos = subtiposDeNomina.filter((e) => e?.id === SUBTIPO_NOMINA_NINGUNO || e?.id === SUBTIPO_NOMINA_EXTEMPORANEO);
    } else {
      _filteredSubtipos = subtiposDeNomina;
      // Aplica Pago de Retroactivo solo aplica a Nómina ordinaria; al cambiar a
      // cualquier otro tipo se oculta el campo, por lo que se limpia su valor.
      setAplicaRetroactivo(false);
      setAplicaRetroactivoPorEmpleado(false);
      form.setFieldsValue({
        aplica_pago_de_retroactivo: false,
        periodos_de_retroactivo: [],
        aplica_calculo_retroactivo_por_empleado: false,
        empleados_a_calcular_retroactivo: [],
      });
    }

    setSubtiposFiltered(_filteredSubtipos);
  };

  const descargarBlobComoArchivo = (blob, nombreArchivo) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleDescargarPlantillaAnticipoAguinaldo = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Anticipo de Aguinaldo');

    const encabezados = [
      'numero_de_empleado', 'importe_de_anticipo_de_aguinaldo', 'periodo_de_aplicacion_del_descuento',
    ];

    const headerRow = worksheet.addRow(encabezados);
    /* eslint-disable no-param-reassign */
    headerRow.eachCell((cell, colNumber) => {
      cell.font = {
        name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' },
      };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF004080' } };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      worksheet.getColumn(colNumber).width = 30;
    });
    /* eslint-enable no-param-reassign */

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    descargarBlobComoArchivo(blob, 'Layout_Anticipo_Aguinaldo.xlsx');
  };

  const handleDescargarLayoutConObservaciones = () => {
    if (!layoutAnticipoAguinaldoErrorBase64) return;
    const byteCharacters = atob(layoutAnticipoAguinaldoErrorBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    descargarBlobComoArchivo(blob, 'Layout_Anticipo_Aguinaldo_Observaciones.xlsx');
  };

  const handleCargarLayoutAnticipoAguinaldo = async (file) => {
    setUploadingAnticipoAguinaldo(true);
    setAnticiposAguinaldoRegistros([]);
    setLayoutAnticipoAguinaldoErrorBase64(null);
    try {
      const respuesta = await postValidarLayoutAnticipoAguinaldo(file);
      if (!respuesta) {
        return false;
      }
      if (!respuesta.valido) {
        if (respuesta.archivo_con_observaciones_base64) {
          setLayoutAnticipoAguinaldoErrorBase64(respuesta.archivo_con_observaciones_base64);
          message.error('El layout tiene errores. Descargue el archivo con las observaciones, corríjalo y vuelva a cargarlo.');
        } else {
          message.error(respuesta.error || 'El layout no es válido.');
        }
        return false;
      }
      setAnticiposAguinaldoRegistros(respuesta.registros || []);
      message.success(`Layout válido: ${respuesta.registros?.length || 0} empleado(s) cargado(s).`);
    } finally {
      setUploadingAnticipoAguinaldo(false);
    }
    return false; // evita que antd Upload intente subir el archivo por su cuenta
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data?.results?.find((item) => item.id === key);
    const _calculo = await getCalculoDeNomina(match.id);
    const _errores = await getNominasErrores({ nomina: _calculo?.id });
    const _origenesDeRecurso = await getNominasOrigenesRecursos({ nomina: match.id });
    setTimeout(() => {
      if (_calculo) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedClone(_calculo));
          // eslint-disable-next-line max-len
          const nomina = tiposNominasEmpleados.find((e) => e.id === _calculo.tipo_de_nomina_empleado);
          setPeriodo(nomina?.periodicidad_de_pago);
          filterPeriodos(_calculo);
          filterSubtipos(_calculo?.tipo_de_nomina);
          setAplicaRetroactivo(_calculo.aplica_pago_de_retroactivo || false);
          setAplicaRetroactivoPorEmpleado(_calculo.aplica_calculo_retroactivo_por_empleado || false);
          setAplicaCalculoPorEmpleado(_calculo.aplica_calculo_por_empleado || false);
          fetchEmpleadosPorTipoNomina(_calculo.tipo_de_nomina_empleado);
          setErrores(_errores);
          setNominasOrigenesRecursos(_origenesDeRecurso);
          setActiveTabNomina('detalle');
          setVisible(true);
          // En caso de no que la nomina aun no este calculada cambiamos el estado para ejecutar el useEffect
          if (!_calculo.nomina_calculada) {
            setRenderizado(true);
            refrescoAplicadoNominaIdRef.current = null;
            setCalculando(true);
          }
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      // Nueva nómina únicamente (editar una ya existente no pasa por aquí, ver
      // selectedRowKeys.length en el botón "Guardar"): si el candado de entidad se
      // activó mientras el formulario estaba abierto, se rechaza aquí también.
      if (!selectedRowKeys.length && bloqueoEntidadEnCurso) {
        notification.warning({
          message: 'Proceso en curso',
          description: 'Hay una Autorización o Cancelación de nómina en curso para esta entidad. Espera a que termine para calcular una nueva nómina.',
          placement: 'topRight',
        });
        return;
      }
      setLoading(true);
      await form.validateFields();

      if (esAnticipoAguinaldo && !anticiposAguinaldoRegistros.length) {
        message.warn('Debe cargar y validar el layout de Anticipo de Aguinaldo antes de guardar.');
        setLoading(false);
        return;
      }

      const values = {
        ...form.getFieldsValue(),
      };

      if (esAnticipoAguinaldo) {
        values.anticipos_aguinaldo = JSON.stringify(anticiposAguinaldoRegistros);
      }

      if (values.fecha_de_calculo) {
        values.fecha_de_calculo = moment(values.fecha_de_calculo).format('YYYY-MM-DD');
      }
      if (values.periodos_de_retroactivo) {
        if (Array.isArray(values.periodos_de_retroactivo)) {
          values.periodos_de_retroactivo = values.periodos_de_retroactivo.map(Number);
        } else if (typeof values.periodos_de_retroactivo === 'string') {
          values.periodos_de_retroactivo = values.periodos_de_retroactivo
            .split(',')
            .map((id) => Number(id.trim()));
        }
      }

      values.periodos_de_retroactivo = values.periodos_de_retroactivo?.length
        ? values.periodos_de_retroactivo
        : undefined;

      const saved = await postCalculosDeNominas(values);
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          setEncabezado(formatReceivedClone(saved));
          // La Nómina recién creada debe quedar en modo "Editar" (no "Detalle"
          // solo lectura): si no, "Guardar y Recalcular" nunca aparece aunque
          // termine el cálculo, porque nominaEditable exige abiertoParaEditar.
          setAbiertoParaEditar(true);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
        setNominaEnProcesoId(saved.id);
        setIsPolling(true); // <-- ACTIVAMOS EL POLLING
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setEncabezado(formatReceivedClone(record));
    form.setFieldsValue(record);
    setCalculando(!!record.fecha_inicia_calculos && !record.fecha_final_calculos);
  };

  const onChangeTabLista = (newTab) => {
    tabListaActivaRef.current = newTab;
    setTabListaActiva(newTab);
    setSelectedRowKeys([]);
    fetchData(1, null, newTab);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    if (bloqueoEntidadEnCurso) {
      notification.warning({
        message: 'Proceso en curso',
        description: 'Hay una Autorización o Cancelación de nómina en curso para esta entidad. Espera a que termine para calcular una nueva nómina.',
        placement: 'topRight',
      });
      return;
    }
    onCancel();
    form.setFieldsValue({
      fecha_de_calculo: moment(new Date().getDate(), 'DD/MM/YYYY'),
    });
    setActiveTabNomina('detalle');
    setVisible(true);
  };

  // ====================== EXCEL NUEVO - FORMATO POR ÁREA ======================
  const handleNuevoExcelExport = async ({ nominas, periodoFiscal, nominasData }) => {
    try {
      setLoading(true);
      message.loading({ content: 'Generando Excel unificado por áreas...', key: 'unificado' });

      const periodoFiscalInfo = periodosFiscales.find((pf) => pf.id === periodoFiscal);
      const periodoFiscalDesc = periodoFiscalInfo?.periodo || periodoFiscalInfo?.nombre || `PF ${periodoFiscal}`;

      const periodosUnicos = new Set();

      (nominasData || []).forEach((nomina) => {
        const { periodoDetalleId } = nomina;

        if (periodoDetalleId) {
          const periodoInfo = periodosNominasDetalles.find((pd) => pd.id === periodoDetalleId);
          if (periodoInfo) {
            const descripcion = `${periodoInfo.numero_de_nomina || 'Sin número'} (${periodoInfo.fecha_inicial ? moment(periodoInfo.fecha_inicial).format('DD/MM/YYYY') : '?'} al ${periodoInfo.fecha_final ? moment(periodoInfo.fecha_final).format('DD/MM/YYYY') : '?'})`;
            periodosUnicos.add(descripcion);
          } else {
            periodosUnicos.add(`Periodo ID: ${periodoDetalleId}`);
          }
        } else {
          periodosUnicos.add(`Nómina ${nomina.numeroNomina || nomina.value} - Sin periodo`);
        }
      });

      const periodosDesc = periodosUnicos.size > 0 ? Array.from(periodosUnicos).join(', ') : 'No especificado';

      const areasMap = new Map();
      let columnasPercepcionesGlobal = [];
      let columnasDeduccionesGlobal = [];
      let columnasDescuentosGlobal = [];

      // Procesar cada nómina
      for (let idx = 0; idx < nominas.length; idx += 1) {
        const nominaId = nominas[idx];
        // eslint-disable-next-line no-await-in-loop
        const response = await API.get(`/nominas/nominas-plazas-vista-optimized/${nominaId}/`);
        const rawData = response.data?.results || response.data || [];
        const allRecords = formatReceivedClone(rawData);

        // eslint-disable-next-line no-await-in-loop
        const nominaInfo = data?.results?.find((n) => n.id === nominaId) || (await getCalculoDeNomina(nominaId));
        const nominaNombre = nominaInfo?.numero_nomina || `Nómina ${nominaId}`;

        let percepcionesData = [];
        let deduccionesData = [];
        let descuentosData = [];
        let percepcionesCatalog = [];
        let deduccionesCatalog = [];
        let descuentosCatalog = [];

        try {
          const percepcionesResponse = await API.get(`/nominas/nominas-plazas-percepciones-vista-optimized/${nominaId}`);
          percepcionesData = percepcionesResponse.data?.results || percepcionesResponse.data || [];
          const percepcionesCatalogResponse = await API.get('/nominas/percepciones/');
          percepcionesCatalog = percepcionesCatalogResponse.data?.results || percepcionesCatalogResponse.data || [];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`[exportación unificada] no se pudieron cargar percepciones de la nómina ${nominaId}`, error);
        }

        try {
          const deduccionesResponse = await API.get(`/nominas/nominas-plazas-deducciones-vista-optimized/${nominaId}`);
          deduccionesData = deduccionesResponse.data?.results || deduccionesResponse.data || [];
          const deduccionesCatalogResponse = await API.get('/nominas/deducciones/');
          deduccionesCatalog = deduccionesCatalogResponse.data?.results || deduccionesCatalogResponse.data || [];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`[exportación unificada] no se pudieron cargar deducciones de la nómina ${nominaId}`, error);
        }

        try {
          const descuentosResponse = await API.get(`/nominas/nominas-plazas-descuentos-vista-optimized/${nominaId}`);
          descuentosData = descuentosResponse.data?.results || descuentosResponse.data || [];
          const descuentosCatalogResponse = await API.get('/nominas/descuentos/');
          descuentosCatalog = descuentosCatalogResponse.data?.results || descuentosCatalogResponse.data || [];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`[exportación unificada] no se pudieron cargar descuentos de la nómina ${nominaId}`, error);
        }

        const percepcionesMap = percepcionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
        const deduccionesMap = deduccionesCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});
        const descuentosMap = descuentosCatalog.reduce((acc, item) => ({ ...acc, [item.id]: item }), {});

        const percepcionesPorPlaza = {};
        percepcionesData.forEach((item) => {
          const plazaId = item.nomina_plaza_id;
          if (!percepcionesPorPlaza[plazaId]) percepcionesPorPlaza[plazaId] = [];
          percepcionesPorPlaza[plazaId].push(item);
        });

        const deduccionesPorPlaza = {};
        deduccionesData.forEach((item) => {
          const plazaId = item.nomina_plaza_id;
          if (!deduccionesPorPlaza[plazaId]) deduccionesPorPlaza[plazaId] = [];
          deduccionesPorPlaza[plazaId].push(item);
        });

        const descuentosPorPlaza = {};
        descuentosData.forEach((item) => {
          const plazaId = item.nomina_plaza_id;
          if (!descuentosPorPlaza[plazaId]) descuentosPorPlaza[plazaId] = [];
          descuentosPorPlaza[plazaId].push(item);
        });

        const nombresPercepciones = new Set();
        percepcionesData.forEach((item) => {
          const percepcion = percepcionesMap[item.percepcion_id];
          if (percepcion && percepcion.descripcion) {
            const clave = percepcion.clave || '';
            const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
            nombresPercepciones.add(nombreColumna);
          }
        });

        const nombresDeducciones = new Set();
        deduccionesData.forEach((item) => {
          const deduccion = deduccionesMap[item.deduccion_id];
          if (deduccion && deduccion.concepto) {
            const clave = deduccion.clave || '';
            const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
            nombresDeducciones.add(nombreColumna);
          }
        });

        const nombresDescuentos = new Set();
        descuentosData.forEach((item) => {
          const descuento = descuentosMap[item.descuento_id];
          if (descuento && descuento.clave_y_concepto) {
            nombresDescuentos.add(descuento.clave_y_concepto);
          }
        });

        const columnasPercepciones = Array.from(nombresPercepciones).sort();
        const columnasDeducciones = Array.from(nombresDeducciones).sort();
        const columnasDescuentos = Array.from(nombresDescuentos).sort();

        columnasPercepcionesGlobal = [...new Set([...columnasPercepcionesGlobal, ...columnasPercepciones])].sort();
        columnasDeduccionesGlobal = [...new Set([...columnasDeduccionesGlobal, ...columnasDeducciones])].sort();
        columnasDescuentosGlobal = [...new Set([...columnasDescuentosGlobal, ...columnasDescuentos])].sort();

        allRecords.forEach((record) => {
          const areaClaveNombre = record.directorio_de_area_clave_y_nombre || 'Sin área';
          if (!areasMap.has(areaClaveNombre)) {
            areasMap.set(areaClaveNombre, { empleados: [] });
          }

          const percepcionesPlaza = percepcionesPorPlaza[record.id] || [];
          const percepcionesMapa = {};
          percepcionesPlaza.forEach((item) => {
            const percepcion = percepcionesMap[item.percepcion_id];
            if (percepcion && percepcion.descripcion) {
              const clave = percepcion.clave || '';
              const nombreColumna = clave ? `${clave} - ${percepcion.descripcion}` : percepcion.descripcion;
              percepcionesMapa[nombreColumna] = (percepcionesMapa[nombreColumna] || 0) + (parseFloat(item.importe) || 0);
            }
          });

          const deduccionesPlaza = deduccionesPorPlaza[record.id] || [];
          const deduccionesMapa = {};
          deduccionesPlaza.forEach((item) => {
            const deduccion = deduccionesMap[item.deduccion_id];
            if (deduccion && deduccion.concepto) {
              const clave = deduccion.clave || '';
              const nombreColumna = clave ? `${clave} - ${deduccion.concepto}` : deduccion.concepto;
              deduccionesMapa[nombreColumna] = (deduccionesMapa[nombreColumna] || 0) + (parseFloat(item.importe) || 0);
            }
          });

          const descuentosPlaza = descuentosPorPlaza[record.id] || [];
          const descuentosMapa = {};
          descuentosPlaza.forEach((item) => {
            const descuento = descuentosMap[item.descuento_id];
            if (descuento && descuento.clave_y_concepto) {
              descuentosMapa[descuento.clave_y_concepto] = (descuentosMapa[descuento.clave_y_concepto] || 0) + (parseFloat(item.importe_descuento) || 0);
            }
          });

          const importeDeducciones = parseFloat(record.importe_deducciones) || 0;
          const importeDescuentos = parseFloat(record.importe_descuentos) || 0;
          const importePercepciones = parseFloat(record.importe_percepciones) || 0;
          const netoAPagar = parseFloat(record.importe_neto) || 0;

          areasMap.get(areaClaveNombre).empleados.push({
            record,
            percepcionesMapa,
            deduccionesMapa,
            descuentosMapa,
            importeDeducciones,
            importeDescuentos,
            importePercepciones,
            netoAPagar,
            nominaOrigen: nominaNombre,
          });
        });
      }

      if (areasMap.size === 0) {
        message.error({ content: 'No se encontraron registros para exportar', key: 'unificado' });
        setLoading(false);
        return;
      }

      // Una fila por empleado y nómina con TODOS los campos del Excel Personalizado (incluido el
      // domicilio congelado) + una columna por percepción/deducción/descuento. El exportador deja
      // elegir columnas y escribe el Excel agrupado por Departamento con subtotales y TOTAL
      // GENERAL. Por defecto vienen seleccionadas las columnas del reporte de siempre.
      const llaveConcepto = (tipo, nombre) => `zz_${tipo}__${nombre}`;
      const conceptos = [
        ...columnasPercepcionesGlobal.map((nombre) => ({ tipo: 'percepcion', nombre, mapa: 'percepcionesMapa' })),
        ...columnasDeduccionesGlobal.map((nombre) => ({ tipo: 'deduccion', nombre, mapa: 'deduccionesMapa' })),
        ...columnasDescuentosGlobal.map((nombre) => ({ tipo: 'descuento', nombre, mapa: 'descuentosMapa' })),
      ];

      const filas = [];
      areasMap.forEach(({ empleados }, areaClaveNombre) => {
        empleados.forEach((empleado) => {
          const fila = {
            ...empleado.record,
            nomina_de_origen: empleado.nominaOrigen,
            departamento_reporte: areaClaveNombre,
            importe_deducciones: empleado.importeDeducciones,
            importe_descuentos: empleado.importeDescuentos,
            importe_percepciones: empleado.importePercepciones,
            importe_neto: empleado.netoAPagar,
          };
          conceptos.forEach(({ tipo, nombre, mapa }) => {
            fila[llaveConcepto(tipo, nombre)] = empleado[mapa][nombre] || 0;
          });
          filas.push(fila);
        });
      });

      const titulos = {
        ...TITULOS_COLUMNAS_NOMINA,
        nomina_de_origen: 'Nómina de Origen',
        departamento_reporte: 'Departamento',
        numero_de_empleado: 'Empleado',
        numero_y_nombre_completo: 'Nombre del Empleado',
        tipo_de_empleado_presupuestal: 'Tipo de Empleado Presupuestal',
        importe_deducciones: 'Importe Deducciones',
        importe_descuentos: 'Importe Descuentos',
        importe_percepciones: 'Importe Percepciones',
        importe_neto: 'Neto a Pagar',
      };
      const formatos = {};
      conceptos.forEach(({ tipo, nombre }) => {
        titulos[llaveConcepto(tipo, nombre)] = nombre;
        formatos[llaveConcepto(tipo, nombre)] = 'moneda';
      });
      Object.keys(filas[0] || {}).filter((llave) => llave.startsWith('importe_')).forEach((llave) => {
        formatos[llave] = 'moneda';
      });

      setReporteNominas({
        filas,
        titulos,
        formatos,
        columnasPorDefecto: [
          'nomina_de_origen',
          'numero_de_empleado',
          'numero_y_nombre_completo',
          'tipo_de_empleado_presupuestal',
          ...conceptos.map(({ tipo, nombre }) => llaveConcepto(tipo, nombre)),
          'importe_deducciones',
          'importe_descuentos',
          'importe_percepciones',
          'importe_neto',
        ],
        encabezado: [
          'Sistema de Nomina',
          'Reporte de Percepciones y Deducciones - Unificado',
          'Compania: Municipio de Tlajomulco de Zúñiga',
          `Periodo Fiscal: ${periodoFiscalDesc}`,
          `Periodo(s): ${periodosDesc}`,
          'Clave Movto.: NN Nómina Normal',
          'Tabla : captura',
        ],
        fileName: `Nominas_Unificadas_PorArea_${moment().format('YYYY-MM-DD_HH-mm')}`,
      });
      message.success({ content: `${filas.length} registros listos: elige las columnas del reporte`, key: 'unificado' });
      setShowNuevoExcelModal(false);
      setShowExportadorReporteNominas(true);
    } catch (err) {
      message.error({ content: 'Error al preparar el reporte de nóminas', key: 'unificado' });
    } finally {
      setLoading(false);
    }
  };

  // ====================== EXCEL DEPÓSITO DE EMPLEADOS RETENIDOS (POR BANCO) ======================
  // "Retenido" = plaza con requiere_cuenta_contable_especifica = true: su pago se deposita
  // en un banco distinto al banco general de la nómina (caso Tlajomulco: BANORTE).
  const handleRetenidosExport = async ({ nominas, periodoFiscal, nominasData }) => {
    try {
      setLoading(true);
      message.loading({ content: 'Generando reporte de depósito de retenidos...', key: 'retenidos' });

      const razonSocial = entidad?.razon_social || entidad?.nombre || '';
      const periodoFiscalInfo = periodosFiscales.find((pf) => pf.id === periodoFiscal);
      const periodoFiscalDesc = periodoFiscalInfo?.periodo || periodoFiscalInfo?.nombre || `PF ${periodoFiscal}`;

      const workbook = XLSX.utils.book_new();
      let hojasGeneradas = 0;
      let totalRetenidosGlobal = 0;

      for (let idx = 0; idx < nominas.length; idx += 1) {
        const nominaId = nominas[idx];
        const nominaOpcion = (nominasData || []).find((n) => n.value === nominaId);
        // eslint-disable-next-line no-await-in-loop
        const response = await API.get(`/nominas/nominas-plazas-vista-optimized/${nominaId}/`);
        const rawData = response.data?.results || response.data || [];
        const allRecords = formatReceivedClone(rawData);

        const retenidos = allRecords.filter((record) => record.requiere_cuenta_contable_especifica);

        const numeroNomina = nominaOpcion?.numeroNomina || `Nomina_${nominaId}`;
        const periodoInfo = nominaOpcion?.periodoDetalleId
          ? periodosNominasDetalles.find((pd) => pd.id === nominaOpcion.periodoDetalleId)
          : null;
        const periodoDesc = periodoInfo
          ? `DEL PERIODO No. ${periodoInfo.numero_de_nomina || ''} ${periodoInfo.fecha_inicial ? moment(periodoInfo.fecha_inicial).format('DD [DE] MMMM [DE] YYYY').toUpperCase() : ''} AL ${periodoInfo.fecha_final ? moment(periodoInfo.fecha_final).format('DD [DE] MMMM [DE] YYYY').toUpperCase() : ''}`
          : '';

        const excelRows = [];
        excelRows.push(['Sistema de Nomina', '', '', 'Depósito de Empleados (Numérico)']);
        excelRows.push([`Municipio de ${razonSocial}`, '', '', nominaOpcion?.tipoNominaDesc || '']);
        excelRows.push([moment().format('DD [de] MMMM [de] YYYY hh:mm a'), '', '', periodoDesc || `Periodo Fiscal: ${periodoFiscalDesc}`]);
        excelRows.push([]);

        if (retenidos.length === 0) {
          excelRows.push(['Sin empleados retenidos en esta nómina (ningún registro con Cuenta Contable para Retención de Pago).']);
        } else {
          const bancosMap = new Map();
          retenidos.forEach((record) => {
            const bancoId = record.banco_id ?? record.banco;
            const bancoInfo = bancos.find((b) => b.id === bancoId);
            const nombreBanco = bancoInfo?.nombre || (bancoId ? `Banco ${bancoId}` : 'Sin banco asignado');
            if (!bancosMap.has(nombreBanco)) bancosMap.set(nombreBanco, []);
            bancosMap.get(nombreBanco).push(record);
          });

          const headersBase = ['Empleado', 'Nombre del Empleado', 'No. de Cuenta o Clave', 'Cantidad a Depositar'];
          let totalEmpleadosCompania = 0;
          let totalDepositarCompania = 0;

          Array.from(bancosMap.keys()).sort().forEach((nombreBanco) => {
            const registrosBanco = bancosMap.get(nombreBanco);

            excelRows.push([`Banco: ${nombreBanco}`]);
            excelRows.push(headersBase);

            let totalBanco = 0;
            registrosBanco.forEach((record) => {
              const nombreCompleto = record.numero_y_nombre_completo
                || `${record.nombre || ''} ${record.apellido_paterno || ''} ${record.apellido_materno || ''}`.trim();
              const importe = parseFloat(record.importe_neto_dispersion_bancaria ?? record.importe_neto) || 0;
              totalBanco += importe;
              // Fallback: si "cuenta_bancaria" (numero_tarjeta) viene vacío, usar clabe o numero_tarjeta,
              // lo que haya capturado — el backend a veces solo tiene uno de los tres.
              const cuentaBancaria = record.cuenta_bancaria || record.clabe || record.numero_tarjeta || '';

              excelRows.push([
                sanitizarCeldaExcel(record.numero_de_empleado || record.empleado_numero || ''),
                sanitizarCeldaExcel(nombreCompleto),
                sanitizarCeldaExcel(cuentaBancaria),
                importe,
              ]);
            });

            excelRows.push([
              `Total de Empleados por Banco: ${registrosBanco.length}`,
              '',
              `Total ${nombreBanco}:`,
              totalBanco,
            ]);
            excelRows.push([]);

            totalEmpleadosCompania += registrosBanco.length;
            totalDepositarCompania += totalBanco;
          });

          excelRows.push([
            `Total de Empleados por Compañía: ${totalEmpleadosCompania}`,
            '',
            'Total a Depositar por Compañía:',
            totalDepositarCompania,
          ]);

          totalRetenidosGlobal += totalEmpleadosCompania;
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excelRows);

        const currencyFormat = '"$"#,##0.00';
        if (worksheet['!ref']) {
          const range = XLSX.utils.decode_range(worksheet['!ref']);
          for (let R = range.s.r; R <= range.e.r; R += 1) {
            const cellRef = XLSX.utils.encode_cell({ c: 3, r: R });
            const cell = worksheet[cellRef];
            if (cell && typeof cell.v === 'number' && !Number.isNaN(cell.v)) {
              cell.t = 'n';
              cell.z = currencyFormat;
            }
          }
        }

        worksheet['!cols'] = [{ wch: 12 }, { wch: 40 }, { wch: 20 }, { wch: 20 }];

        const sheetName = String(numeroNomina).replace(/[[\]:*?/\\]/g, '_').slice(0, 31);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || `Nomina_${idx + 1}`);
        hojasGeneradas += 1;
      }

      if (hojasGeneradas === 0) {
        message.error({ content: 'No se encontraron nóminas para exportar', key: 'retenidos' });
        setLoading(false);
        return;
      }

      const fecha = moment().format('YYYY-MM-DD_HH-mm');
      XLSX.writeFile(workbook, `Deposito_Retenidos_${fecha}.xlsx`);

      message.success({
        content: `Reporte generado: ${hojasGeneradas} nómina(s), ${totalRetenidosGlobal} empleado(s) retenido(s)`,
        key: 'retenidos',
      });
      setShowRetenidosModal(false);
    } catch (err) {
      message.error({ content: 'Error al generar el reporte de depósito de retenidos', key: 'retenidos' });
    } finally {
      setLoading(false);
    }
  };

  // ====================== FUNCIONES DE EXPORTACIÓN ORIGINALES ======================
  // Excel Personalizado de la nómina seleccionada: mismos datos y formato que el detalle de la
  // nómina (CalculoDeNominas.jsx). Se consultan al abrir para no exportar información vieja.
  const onClickExportarPersonalizado = async () => {
    const [key] = selectedRowKeys;
    if (!key) {
      message.warn('Seleccione una nómina para exportar.');
      return;
    }
    try {
      setLoading(true);
      const response = await API.get(`/nominas/nominas-plazas-vista-optimized/${key}/`);
      const rawData = response.data?.results || response.data || [];
      const registros = rawData.map((e) => {
        const registro = formatReceivedValues(e);
        return { ...registro, nombre_empleado: registro?.empleado, numero_empleado: registro?.empleado };
      });
      if (!registros.length) {
        message.info('La nómina seleccionada no tiene registros para exportar.');
        setLoading(false);
        return;
      }
      setDatosExportadorPersonalizado(registros);
      // `data` es la respuesta paginada ({ count, results }), no una lista
      const nominaSeleccionada = (data?.results || []).find((n) => n.id === key);
      setFolioExportadorPersonalizado(nominaSeleccionada?.numero_nomina || key);
      setShowExportadorPersonalizado(true);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickExportarExcel = async () => {
    const excel = await descargarExcel(selectedRowKeys[0]);
    if (excel) {
      const blob = new Blob([excel], {
        type: 'application/ms-excel',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'NominaPlazas.xls';
      link.click();
    }
  };

  const onClickExportarPDF = async (nominaPlazaID) => {
    try {
      setLoading(true);

      const pdf = await descargarPDF(nominaPlazaID);
      const _nomina = data.results?.filter((item) => item.id === selectedRowKeys[0]);

      const _nominaPlazaResponse = await getNominasPlazas({ nomina_id: selectedRowKeys[0] });
      const _nominaPlaza = _nominaPlazaResponse.results?.[0];

      if (!_nominaPlaza || !_nominaPlaza.empleado) {
        throw new Error('No se encontró información válida de la nómina/plaza/empleado.');
      }

      const _empleado = await getEmpleado(_nominaPlaza.empleado);

      if (!pdf || !_empleado) {
        throw new Error('No se pudo generar el PDF por falta de datos del empleado o del archivo.');
      }

      const blob = new Blob([pdf], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Nomina${_nomina[0]?.numero_nomina || ''}_Empleado${_empleado?.numero_de_empleado || 'Desconocido'}.pdf`;
      link.click();
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickExportarPDFZIP = async () => {
    try {
      setLoading(true);
      const zip = await descargarZIP(selectedRowKeys[0]);
      const _nomina = await getCalculoDeNomina(selectedRowKeys[0]);
      const blob = new Blob([zip], {
        type: 'application/zip',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `Nomina${_nomina.numero_nomina}_Recibos.zip`;
      link.click();

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const exportarReporte = async () => {
    try {
      const pdf = await descargarResumenNomina(selectedRowKeys[0]);
      const _nomina = await getCalculoDeNomina(selectedRowKeys[0]);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `RESUMEN-NOMINA-${_nomina.numero_nomina}.pdf`;
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const exportarRelacion = async () => {
    try {
      const pdf = await descargarRelacionRecibo(selectedRowKeys[0]);
      const _nomina = await getCalculoDeNomina(selectedRowKeys[0]);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `RELACION-RECIBO-${_nomina.numero_nomina}.pdf`;
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const exportarListadoRetencionDePago = async () => {
    try {
      const pdf = await descargarListadoRetencionDePago(selectedRowKeys[0]);
      const _nomina = await getCalculoDeNomina(selectedRowKeys[0]);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `LISTADO-RETENCION-DE-PAGO-${_nomina.numero_nomina}.pdf`;
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleExportPDF = () => {
    const fileName = permission?.model ? permission?.model : 'TABLA';
    const allData = data.map((record) => columns.reduce((acc, column) => {
      const render = column?.render;
      if (render !== undefined) {
        acc[column.titleText] = render(record[column.dataIndex]);
      } else {
        acc[column.titleText] = record[column.dataIndex];
      }
      return acc;
    }, {}));

    const dataCols = columns.length > 9 ? [...columns.slice(0, 9), columns[columns.length - 1]] : columns;
    const dataFiltered = allData.map((objeto) => {
      const dataColumns = Object.keys(objeto);
      const dataColumnsSlice = dataColumns.slice(0, 9);
      const dataColumnsFiltered = dataColumns.length > 9 ? [...dataColumnsSlice, dataColumns[dataColumns.length - 1]] : dataColumnsSlice;
      const newObject = {};
      dataColumnsFiltered.forEach((col) => {
        newObject[col] = objeto[col];
      });
      return newObject;
    });
    const tableData = dataFiltered.map((element) => {
      const tableRow = {};
      dataCols.forEach((column) => {
        tableRow[column.key] = element[column.titleText];
        if (tableRow[column.key] === undefined) {
          tableRow[column.key] = '';
        }
      });
      return tableRow;
    });
    const currentDate = new Date();
    const formattedDate = format(currentDate, "eeee, dd 'de' MMMM 'de' yyyy", { locale: es });
    const entidadId = entidad.id;
    PDFTest(entidadId, dataCols, tableData, fileName, formattedDate);
  };

  const PDFTest = async (entidadId, colsFinal, dataFinal, name, date) => {
    try {
      await descargarPDFGeneral(entidadId, titleTable, colsFinal, dataFinal, date)
        .then((pdfData) => {
          const blob = new Blob([pdfData], {
            type: 'application/pdf',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${name}.pdf`;
          link.click();
        });
    } catch (err) {
      onError(err);
    }
  };

  const registrosNominas = data?.results || [];
  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'nominas',
    contentTypeModel: 'nomina',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Nóminas',
    moduloOrigenLabel: 'Cálculo de Nóminas',
    registros: registrosNominas,
    seleccionIds: selectedRowKeys,
    registroActivo: open && selectedRowKeys.length
      ? registrosNominas.find((e) => e.id === selectedRowKeys[0]) || { id: selectedRowKeys[0] }
      : null,
    mutable: true,
    getRegistroLabel: (row) => `Nómina ${row.numero_nomina || row.id}`,
  });

  const columns = [
  // 1. No. de Nómina
    {
      titleText: 'No. de Nómina',
      dataIndex: 'numero_nomina',
      key: 'numero_nomina',
      width: 200,
    },
    // 2. Fecha
    {
      titleText: 'Fecha',
      dataIndex: 'fecha_de_calculo',
      key: 'fecha_de_calculo',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    // 3. Folio Agrupador
    {
      titleText: 'Folio Agrupador',
      dataIndex: 'folio_agrupador',
      key: 'folio_agrupador',
      width: 200,
    },
    // 4. Tipo de Nómina Empleado
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 250,
    },
    // 5. Tipo de Nómina
    {
      titleText: 'Tipo de Nómina',
      dataIndex: 'tipo_de_nomina_descripcion',
      key: 'tipo_de_nomina_descripcion',
      width: 250,
    },
    // 6. Concepto de Pago
    {
      titleText: 'Concepto de Pago',
      dataIndex: 'tipo_de_nomina_empleado_periodicidad',
      key: 'tipo_de_nomina_empleado_periodicidad',
      width: 200,
      render: (val) => {
        const _tipoNominaEmpleado = tiposNominasEmpleados?.find((e) => e.id === val);
        const _periodicidad = periodicidades?.find((e) => e.id === _tipoNominaEmpleado?.periodicidad_de_pago)?.descripcion;
        return _periodicidad;
      },
    },
    // 7. Subtipo de Nómina
    {
      titleText: 'Subtipo de Nómina',
      dataIndex: 'subtipo_de_nomina_descripcion',
      key: 'subtipo_de_nomina_descripcion',
      width: 200,
    },
    // 8. Periodo de Pago
    {
      titleText: 'Periodo de Pago',
      dataIndex: 'tipo_de_nomina_empleado',
      // El campo es el id del tipo de nómina empleado, pero se muestra (y se busca) su
      // periodicidad: la Búsqueda usa el filtro de texto del backend, no el de id (400).
      searchKey: 'tipo_de_nomina_empleado_periodicidad',
      width: 200,
      render: (val) => {
        const _tipoNominaEmpleado = tiposNominasEmpleados?.find((e) => e.id === val);
        const _periodicidad = periodicidades?.find((e) => e.id === _tipoNominaEmpleado?.periodicidad_de_pago)?.descripcion;
        return _periodicidad;
      },
    },
    // 9. Fecha Inicial de Pago
    {
      titleText: 'Fecha Inicial de Pago',
      dataIndex: 'fecha_inicial_nomina',
      key: 'fecha_inicial_nomina',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    // 10. Fecha Final de Pago
    {
      titleText: 'Fecha Final de Pago',
      dataIndex: 'fecha_final_nomina',
      key: 'fecha_final_nomina',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    // 11. Número de Días de Pago
    {
      titleText: 'Número de Días de Pago',
      dataIndex: 'dias_calculados',
      key: 'dias_calculados',
      width: 200,
    },
    // 12. Número de Empleados
    {
      titleText: 'Número de Empleados',
      dataIndex: 'numero_plazas_calculadas',
      key: 'numero_plazas_calculadas',
      width: 150,
    },
    // 13. Importe Neto
    {
      titleText: 'Importe Neto',
      dataIndex: 'importe_neto',
      key: 'importe_neto',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    // 14. Estatus
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 200,
      // Tag con color por estatus (mismo criterio que Registro de Incidencias y
      // Asignación de Plazas). Se decide por el texto porque el Table a veces llama a
      // render sin el registro (ordenamiento).
      render: (descripcion) => {
        if (!descripcion) return null;
        const upper = String(descripcion).toUpperCase();
        let color = 'blue';
        if (upper.includes('AUTORIZ')) color = 'green';
        if (upper.includes('CANCEL')) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  const columnsNominasOrigenesRecursos = [
    {
      titleText: 'Origen del Recurso del SAT',
      dataIndex: 'origen_recurso_nomina',
      key: 'origen_recurso_nomina',
      render: (val) => {
        if (val == null) return '';
        const origenesSat = origenesRecursosSAT?.find((origen) => origen?.id === val);
        if (!origenesSat) return '';
        return `${origenesSat.clave} - ${origenesSat.descripcion}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    descripcion: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  const onConfirmAuthorize = async () => {
    try {
      if (bloqueoEntidadEnCurso) {
        setVisibleConfirmAuthorize(false);
        notification.warning({
          message: 'Proceso en curso',
          description: 'Ya hay una Autorización o Cancelación de nómina en curso para esta entidad. Espera a que termine.',
          placement: 'topRight',
        });
        return;
      }
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }

      const res = await autorizarNomina(key);
      if (res?.status === 200) {
        onSuccess(res);
        await fetchData(pageActual); // actualiza usando la página actual
        setVisibleConfirmAuthorize(false);
        if (res.data?.descuentos_saldo_task_id) {
          setSaldoTaskAccion('autorizar');
          setSaldoTaskId(res.data.descuentos_saldo_task_id);
          notification.info({
            message: 'Actualizando saldos de descuentos…',
            description: 'La nómina ya quedó autorizada. Estamos actualizando en segundo plano el saldo de sus descuentos con control de saldo; te avisamos en cuanto termine.',
            placement: 'topRight',
          });
        }
      }

      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onConfirmCancelar = async () => {
    try {
      if (bloqueoEntidadEnCurso) {
        setVisibleCancelar(false);
        notification.warning({
          message: 'Proceso en curso',
          description: 'Ya hay una Autorización o Cancelación de nómina en curso para esta entidad. Espera a que termine.',
          placement: 'topRight',
        });
        return;
      }
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede modificar una nómina ya cancelada');
        return;
      }
      const res = await cancelarNomina(key);
      if (res?.status === 200) {
        onSuccess(res);
        await fetchData(pageActual); // <-- usa la página actual
        setVisibleCancelar(false);
        if (res.data?.descuentos_saldo_task_id) {
          setSaldoTaskAccion('cancelar');
          setSaldoTaskId(res.data.descuentos_saldo_task_id);
          notification.info({
            message: 'Actualizando saldos de descuentos…',
            description: 'La nómina ya quedó cancelada. Estamos revirtiendo en segundo plano el saldo de sus descuentos con control de saldo; te avisamos en cuanto termine.',
            placement: 'topRight',
          });
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onErrors = () => {
    setVisibleErrores(true);
  };

  const menuExportar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Excel de Nómina',
          text: 'Excel de Nómina',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarExcel(),
          disabledBySelection: true,
        },
        {
          key: 'excel_personalizado',
          label: 'Excel Personalizado (Seleccionar columnas)',
          text: 'Excel Personalizado (Seleccionar columnas)',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarPersonalizado(),
          disabledBySelection: true,
        },
        {
          key: 2,
          label: 'Recibos Administrativos',
          text: 'Recibos Administrativos',
          icon: <FilePdfOutlined />,
          onClick: () => onClickExportarPDFZIP(),
          disabledBySelection: true,
        },
        {
          key: 3,
          label: 'PDF',
          text: 'PDF',
          icon: <FilePdfOutlined />,
          onClick: () => handleExportPDF(),
          disabledBySelection: false,
        },
      ]}
    />
  );

  const reportsMenu = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Resumen Nómina',
          text: 'Resumen Nómina',
          icon: <FaMoneyBill />,
          onClick: () => exportarReporte(),
        },
        {
          key: 2,
          label: 'Relación de Recibos',
          text: 'Relación de Recibos',
          icon: <FaGgCircle />,
          onClick: () => exportarRelacion(),
        },
        {
          key: 3,
          label: 'Listado de Retención de Pagos',
          text: 'Listado de Retención de Pagos',
          icon: <UnorderedListOutlined />,
          onClick: () => exportarListadoRetencionDePago(),
          disabledBySelection: false,
        },
      ]}
      disabled={!selectedRowKeys.length}
    />
  );

  // Mismo límite que el backend (_MAX_MINUTOS_CALCULO): locks de más de 30 min se ignoran
  const _LIMITE_CALCULO_MIN = 30;
  const otraEnCalculo = (data?.results || []).some((row) => {
    if (!row.fecha_inicia_calculos || row.fecha_final_calculos) return false;
    if (Number(row.id) === Number(encabezado?.id)) return false;
    return moment().diff(moment(row.fecha_inicia_calculos), 'minutes') <= _LIMITE_CALCULO_MIN;
  });

  // ── Acciones por estatus ──────────────────────────────────────────────
  // Cada acción se habilita solo si la nómina seleccionada está en un estatus válido
  // para ella (además del bloqueo por proceso en curso). Los tabs por estatus
  // muestran solo sus acciones; "Todos" muestra todas y el estatus decide.
  const nominaSeleccionada = (data?.results || []).find((row) => row.id === selectedRowKeys[0]);
  const seleccionEnEstados = (estadosPermitidos) => !!nominaSeleccionada
    && estadosPermitidos.includes(nominaSeleccionada.estados_globales);

  const accionCancelar = {
    permission: { model: 'nomina', action: 'cancelar' },
    onClick: () => setVisibleCancelar(true),
    text: 'Cancelar',
    icon: <CloseCircleOutlined />,
    disabledBySelection: false,
    className: 'cancel',
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]) || bloqueoEntidadEnCurso,
  };

  const accionAutorizar = {
    onClick: () => setVisibleConfirmAuthorize(true),
    text: 'Autorizar',
    icon: <CheckCircleOutlined />,
    permission: { model: 'nomina', action: 'autorizar' },
    disabledBySelection: false,
    className: 'success',
    disabled: !seleccionEnEstados([ESTATUS_ACTIVO]) || bloqueoEntidadEnCurso,
  };

  const accionReporte = {
    onClick: () => setShowNuevoExcelModal(true),
    text: 'Reporte Nominas',
    icon: <FileExcelOutlined />,
    disabledBySelection: false,
    disabled: false,
  };

  // "Editar" (junto a "Detalle"): abre el mismo formulario, pero solo se habilita con una
  // nómina Activa y sin proceso en curso, que es cuando sus campos se pueden modificar;
  // "Detalle" sigue abriendo cualquier nómina (solo lectura si no está Activa).
  const disableEditarNomina = !seleccionEnEstados([ESTATUS_ACTIVO]) || bloqueoEntidadEnCurso;

  // Formulario abierto con "Detalle": solo consulta (nada se puede modificar ni guardar,
  // aunque la nómina esté Activa). Con "Editar" (o al Agregar) aplica la regla de siempre:
  // solo una nómina Activa es editable.
  const soloConsulta = selectedRowKeys.length > 0 && !abiertoParaEditar;
  const nominaEditable = encabezado?.estados_globales === 1 && !soloConsulta;

  const renderTablaNominas = ({ controls, customActions }) => (
    seguimiento.conBarra(<Table
      cols={[seguimiento.columnaSeguimiento, ...columns]}
      data={data?.results || []}
      pagination={false}
      paginationCallback={fetchPaginated}
      count={data?.count || 0}
      titleTable="Cálculo Nómina"
      storageId={TABLE_STORAGE_ID}
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      controls={controls}
      customExportMenu={menuExportar}
      allowCustomExport
      customActions={[...(customActions || []), seguimiento.accionSeguimiento]}
      customActionsDropdown
      customActionsDropdownText="Acciones"
      secondaryEditText="Editar"
      disableSecondaryEdit={disableEditarNomina}
      allowReports
      reportsMenu={reportsMenu}
      editText="Detalle"
      permission={permission}
    />)
  );

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Card bordered={false} className="tables-container">
            {bloqueoEntidadEnCurso && (
              <Alert
                message="Cálculo, Autorización o Cancelación en curso"
                description="Hay un proceso de Cálculo, Autorización o Cancelación de nómina en curso. No se puede calcular, autorizar ni cancelar otra nómina hasta que termine."
                type="warning"
                showIcon
                icon={<SyncOutlined spin />}
                style={{ marginBottom: 8 }}
              />
            )}
            <Tabs
              activeKey={tabListaActiva}
              onChange={onChangeTabLista}
              items={[
                {
                  key: 'todos',
                  label: 'Todos',
                  // Todas las acciones visibles; cada una se habilita según el estatus
                  // de la nómina seleccionada.
                  children: renderTablaNominas({
                    controls: {
                      onClickAdd,
                      onClickEdit: () => { setAbiertoParaEditar(false); onClickEdit(); },
                      onClickSecondaryEdit: () => { setAbiertoParaEditar(true); onClickEdit(); },
                    },
                    customActions: [accionAutorizar, accionCancelar, accionReporte],
                  }),
                },
                {
                  key: 'activas',
                  label: 'Activas',
                  children: (
                    seguimiento.conBarra(<Table
                      cols={[seguimiento.columnaSeguimiento, ...columns]}
                      data={data?.results || []}
                      pagination={false}
                      paginationCallback={fetchPaginated}
                      count={data?.count || 0}
                      titleTable="Cálculo Nómina"
                      rowSelection={rowSelection}
                      handleOnRowClick={handleOnRowClick}
                      controls={{
                        onClickAdd,
                        onClickEdit: () => { setAbiertoParaEditar(true); onClickEdit(); },
                      }}
                      customExportMenu={menuExportar}
                      allowCustomExport
                      customActions={[
                        seguimiento.accionSeguimiento,
                        {
                          permission: { model: 'nomina', action: 'cancelar' },
                          onClick: () => setVisibleCancelar(true),
                          text: 'Cancelar',
                          icon: <CloseCircleOutlined />,
                          disabledBySelection: false,
                          className: 'cancel',
                          disabled: !selectedRowKeys?.length || bloqueoEntidadEnCurso,
                        },
                        {
                          onClick: () => setVisibleConfirmAuthorize(true),
                          text: 'Autorizar',
                          icon: <CheckCircleOutlined />,
                          permission: { model: 'nomina', action: 'autorizar' },
                          disabledBySelection: false,
                          className: 'success',
                          disabled: !selectedRowKeys?.length || bloqueoEntidadEnCurso,
                        },
                        {
                          onClick: () => setShowNuevoExcelModal(true),
                          text: 'Reporte Nominas',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                        {
                          onClick: () => setShowRetenidosModal(true),
                          text: 'Reporte Depósito Retenidos',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                      ]}
                      // Botón "Reportes"
                      // allowReports
                      // reportsMenu={reportsMenu}
                      editText="Editar"
                      permission={permission}
                    />)
                  ),
                },
                {
                  key: 'autorizadas',
                  label: 'Autorizadas',
                  children: (
                    seguimiento.conBarra(<Table
                      cols={[seguimiento.columnaSeguimiento, ...columns]}
                      data={data?.results || []}
                      pagination={false}
                      paginationCallback={fetchPaginated}
                      count={data?.count || 0}
                      titleTable="Cálculo Nómina"
                      rowSelection={rowSelection}
                      handleOnRowClick={handleOnRowClick}
                      controls={{
                        onClickEdit: () => onClickEdit(),
                      }}
                      customExportMenu={menuExportar}
                      allowCustomExport
                      customActions={[
                        seguimiento.accionSeguimiento,
                        {
                          permission: { model: 'nomina', action: 'cancelar' },
                          onClick: () => setVisibleCancelar(true),
                          text: 'Cancelar',
                          icon: <CloseCircleOutlined />,
                          disabledBySelection: false,
                          className: 'cancel',
                          disabled: !selectedRowKeys?.length || bloqueoEntidadEnCurso,
                        },
                        {
                          onClick: () => setShowNuevoExcelModal(true),
                          text: 'Reporte Nominas',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                        {
                          onClick: () => setShowRetenidosModal(true),
                          text: 'Reporte Depósito Retenidos',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                      ]}
                      // Botón "Reportes" oculto a pedido del usuario (2026-09-24) — se deja comentado, no eliminado
                      // allowReports
                      // reportsMenu={reportsMenu}
                      editText="Detalle"
                      permission={permission}
                    />)
                  ),
                },
                {
                  key: 'canceladas',
                  label: 'Canceladas',
                  children: (
                    seguimiento.conBarra(<Table
                      cols={[seguimiento.columnaSeguimiento, ...columns]}
                      data={data?.results || []}
                      pagination={false}
                      paginationCallback={fetchPaginated}
                      count={data?.count || 0}
                      titleTable="Cálculo Nómina"
                      rowSelection={rowSelection}
                      handleOnRowClick={handleOnRowClick}
                      controls={{
                        onClickEdit: () => onClickEdit(),
                      }}
                      customExportMenu={menuExportar}
                      allowCustomExport
                      customActions={[
                        seguimiento.accionSeguimiento,
                        {
                          onClick: () => setShowNuevoExcelModal(true),
                          text: 'Reporte Nominas',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                        {
                          onClick: () => setShowRetenidosModal(true),
                          text: 'Reporte Depósito Retenidos',
                          icon: <FileExcelOutlined />,
                          disabledBySelection: false,
                          disabled: false,
                        },
                      ]}
                      // Botón "Reportes" oculto a pedido del usuario (2026-09-24) — se deja comentado, no eliminado
                      // allowReports
                      // reportsMenu={reportsMenu}
                      editText="Detalle"
                      permission={permission}
                    />)
                  ),
                },
              ]}
            />
          </Card>
        ) : (
          <>
            {
              errores.length ? (
                <Alert
                  description={(
                    <code>
                      <Text>
                        Ha ocurrido un error
                      </Text>
                      <br />
                      Favor de consultar el
                      <Text
                        style={{
                          color: '#CF9660',
                          paddingLeft: '3px',
                          paddingRight: '3px',
                        }}
                      >
                        Historial de Errores
                      </Text>
                      para obtener mas información
                    </code>
                )}
                  type="warning"
                  showIcon
                  closable
                  style={{ textAlign: 'center', alignItems: 'center' }}
                />
              ) : null
            }
            {bloqueoEntidadEnCurso && (
              <Alert
                message="Cálculo, Autorización o Cancelación en curso"
                description="Hay un proceso de Cálculo, Autorización o Cancelación de nómina en curso. No se puede calcular, autorizar ni cancelar otra nómina hasta que termine."
                type="warning"
                showIcon
                icon={<SyncOutlined spin />}
                style={{ marginBottom: 8 }}
              />
            )}
            {otraEnCalculo && (
              <Alert
                message="Cálculo en curso"
                description="Otra nómina está siendo calculada. No se puede iniciar un nuevo cálculo hasta que termine."
                type="warning"
                showIcon
                style={{ marginBottom: 8 }}
              />
            )}
            <Card
              className="form-container"
              title={`${(() => {
                if (!selectedRowKeys.length) return 'Agregar';
                return abiertoParaEditar ? 'Editar' : 'Detalle';
              })()} Nómina`}
              extra={(
                <FormSubmitControls
                  onFinish={() => form.submit()}
                  mutable={!selectedRowKeys.length}
                  onCancel={onCancel}
                  loading={loading}
                  onErrors={errores.length ? onErrors : null}
                  customActions={selectedRowKeys.length > 0 && nominaEditable && permission?.add ? [
                    {
                      onClick: onGuardarYRecalcular,
                      text: 'Guardar y Recalcular',
                      icon: <SyncOutlined />,
                      disabled: calculando || loadingRecalcular || otraEnCalculo,
                    },
                  ] : []}
                />
              )}
              bordered={false}
            >
              {seguimiento.envolverConSeguimiento(
                <Tabs
                  type="card"
                  activeKey={activeTabNomina}
                  onChange={setActiveTabNomina}
                >
                  <Tabs.TabPane
                    tab="Detalle Nómina"
                    key="detalle"
                    forceRender
                  >
                    <Form
                      layout="vertical"
                      form={form}
                      onFinish={onFinish}
                      name="general"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_de_calculo"
                            label="Fecha"
                            hasFeedback
                          >
                            <DatePicker
                              allowClear
                              format="DD/MM/YYYY"
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_nomina_empleado"
                            label="Tipo de Nómina Empleado"
                            rules={rules.estatus}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposNominasEmpleados}
                              onChange={(value) => {
                                const nomina = tiposNominasEmpleados.find((e) => e.id === value);
                                setPeriodo(nomina?.periodicidad_de_pago);
                                form.resetFields(['periodo_de_nomina_detalle', 'periodo_fiscal', 'dias_calculados', 'empleados_a_calcular', 'empleados_a_calcular_retroactivo']);
                                filterPeriodos();
                                fetchEmpleadosPorTipoNomina(value);
                              }}
                              disabled={selectedRowKeys.length}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Periodicidad de Pago"
                            hasFeedback
                          >
                            <Select
                              dataSource={periodicidades}
                              value={periodo}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_nomina"
                            label="Tipo de Nómina"
                            rules={rules.estatus}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposNominas}
                              disabled={selectedRowKeys.length}
                              value={false}
                              onChange={(value) => filterSubtipos(value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="numero_nomina"
                            label="No. de Nómina"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodo_fiscal"
                            label="Periodo Fiscal"
                            rules={rules.estatus}
                            hasFeedback
                          >
                            <Select
                              dataSource={periodosFiscales}
                              disabled={selectedRowKeys.length}
                              onChange={() => {
                                form.resetFields(['periodo_de_nomina_detalle', 'dias_calculados']);
                                filterPeriodos();
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodo_de_nomina_detalle"
                            label="Periodo"
                            rules={rules.estatus}
                            hasFeedback
                          >
                            <Select
                              keyProp="id"
                              labelProp="numero_de_nomina"
                              disabled={selectedRowKeys.length}
                              dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))}
                              render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                              onChange={(val) => {
                                const _periodo = periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id));
                                const _diasCalculados = _periodo?.find((e) => e.id === val)?.no_de_dias;
                                form.setFieldValue('dias_calculados', _diasCalculados);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="dias_calculados"
                            label="No. de Días"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="folio_agrupador"
                            label="Folio Agrupador"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="la_nomina_pasa_a_cxp"
                            rules={rules.required}
                            label="¿La Nómina Requiere Pasar a CxP?"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={selectedRowKeys.length}
                            />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="subtipo_de_nomina"
                            label="Subtipo de Nómina Especial"
                            initialValue={SUBTIPO_NOMINA_NINGUNO}
                          >
                            <Select
                              dataSource={subtiposFiltered}
                              disabled={disableSubtipo || selectedRowKeys.length}
                            />
                          </Form.Item>
                        </Col>
                        {tipoDeNominaWatch === NOMINA_ORDINARIA && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_pago_de_retroactivo"
                            label="Aplica Pago de Retroactivo"
                            initialValue={false}
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={selectedRowKeys.length > 0}
                              onChange={(value) => {
                                setAplicaRetroactivo(value);
                                if (!value) {
                                  setAplicaRetroactivoPorEmpleado(false);
                                  form.setFieldsValue({
                                    periodos_de_retroactivo: [],
                                    aplica_calculo_retroactivo_por_empleado: false,
                                    empleados_a_calcular_retroactivo: [],
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        )}

                        {tipoDeNominaWatch === NOMINA_ORDINARIA && aplicaRetroactivo && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodos_de_retroactivo"
                            label="Periodos de Retroactivo"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              mode="multiple"
                              keyProp="id"
                              disabled={selectedRowKeys.length > 0}
                              dataSource={periodosNominasDetalles.filter((e) => periodosFiltered.some((x) => x.id === e.id))} // <-- SOLUCIÓN APLICADA
                              render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                            />
                          </Form.Item>
                        </Col>
                        )}

                        {tipoDeNominaWatch === NOMINA_ORDINARIA && aplicaRetroactivo && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_calculo_retroactivo_por_empleado"
                            label={`Aplica Cálculo Retroactivo por ${sujetoLabels.singular}`}
                            initialValue={false}
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={selectedRowKeys.length > 0}
                              onChange={(value) => {
                                setAplicaRetroactivoPorEmpleado(value);
                                if (!value) {
                                  form.setFieldsValue({ empleados_a_calcular_retroactivo: [] });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        )}

                        {tipoDeNominaWatch === NOMINA_ORDINARIA && aplicaRetroactivo && aplicaRetroactivoPorEmpleado && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              name="empleados_a_calcular_retroactivo"
                              label={`${sujetoLabels.plural} a Calcular Retroactivo`}
                              rules={rules.required}
                              hasFeedback
                            >
                              <Select
                                mode="multiple"
                                keyProp="id"
                                disabled={selectedRowKeys.length > 0}
                                loading={loadingEmpleados}
                                dataSource={empleadosDisponibles}
                                render={(e) => e?.numero_y_nombre_completo || `${e?.numero_de_empleado || ''} - ${e?.nombre_completo || ''}`.trim()}
                              />
                            </Form.Item>
                          </Col>
                        )}

                        {!esAnticipoAguinaldo && (
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_calculo_por_empleado"
                            label={`Aplica Cálculo por ${sujetoLabels.singular}`}
                            initialValue={false}
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={selectedRowKeys.length > 0 && !nominaEditable}
                              onChange={(value) => {
                                setAplicaCalculoPorEmpleado(value);
                                if (!value) {
                                  form.setFieldsValue({ empleados_a_calcular: [] });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        )}

                        {!esAnticipoAguinaldo && aplicaCalculoPorEmpleado && (
                          <Col xs={24} sm={24} md={8}>
                            <Form.Item
                              name="empleados_a_calcular"
                              label={`${sujetoLabels.plural} a Calcular`}
                              rules={rules.required}
                              hasFeedback
                            >
                              <Select
                                mode="multiple"
                                keyProp="id"
                                disabled={selectedRowKeys.length > 0 && !nominaEditable}
                                loading={loadingEmpleados}
                                dataSource={empleadosDisponibles}
                                render={(e) => e?.numero_y_nombre_completo || `${e?.numero_de_empleado || ''} - ${e?.nombre_completo || ''}`.trim()}
                              />
                            </Form.Item>
                          </Col>
                        )}

                        {esAnticipoAguinaldo && (
                          <Col xs={24} sm={24} md={24}>
                            <Form.Item label="Layout de Anticipo de Aguinaldo">
                              <Row gutter={10} align="middle">
                                <Col>
                                  <Button
                                    icon={<DownloadOutlined />}
                                    onClick={handleDescargarPlantillaAnticipoAguinaldo}
                                  >
                                    Descargar Plantilla
                                  </Button>
                                </Col>
                                {selectedRowKeys.length > 0 && (
                                  <Col>
                                    <Switch
                                      checkedChildren="Reemplazar Todos"
                                      unCheckedChildren="Agregar / Actualizar"
                                      checked={modoCargaAnticipoAguinaldo === 'reemplazar'}
                                      disabled={!nominaEditable}
                                      onChange={(checked) => setModoCargaAnticipoAguinaldo(checked ? 'reemplazar' : 'agregar')}
                                    />
                                  </Col>
                                )}
                                <Col>
                                  <Upload
                                    accept=".xlsx"
                                    showUploadList={false}
                                    disabled={selectedRowKeys.length > 0 && !nominaEditable}
                                    beforeUpload={handleCargarLayoutAnticipoAguinaldo}
                                  >
                                    <Button
                                      icon={<UploadOutlined />}
                                      loading={uploadingAnticipoAguinaldo}
                                      disabled={selectedRowKeys.length > 0 && !nominaEditable}
                                    >
                                      Cargar Layout
                                    </Button>
                                  </Upload>
                                </Col>
                                {layoutAnticipoAguinaldoErrorBase64 && (
                                  <Col>
                                    <Button
                                      danger
                                      icon={<DownloadOutlined />}
                                      onClick={handleDescargarLayoutConObservaciones}
                                    >
                                      Descargar Layout con Observaciones
                                    </Button>
                                  </Col>
                                )}
                                {!!anticiposAguinaldoRegistros.length && (
                                  <Col>
                                    <Alert
                                      type="success"
                                      showIcon
                                      message={`${anticiposAguinaldoRegistros.length} Empleado(s) Cargado(s) Correctamente.`}
                                    />
                                  </Col>
                                )}
                              </Row>
                            </Form.Item>
                          </Col>
                        )}

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="estados_globales"
                            label="Estatus"
                            rules={rules.estatus}
                            hasFeedback
                            initialValue={1}
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={estados}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="numero_plazas_calculadas"
                            label={`Número de ${sujetoLabels.plural}`}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        ...
                      </Row>

                      {selectedRowKeys?.length ? (
                        <CalculoDeNomina
                          onClickExportarPDF={onClickExportarPDF}
                          permission={getPermission}
                          selected={selectedRowKeys[0]}
                          encabezado={encabezado}
                          fetchEncabezado={fetchData}
                          calculando={calculando}
                          onEncabezadoUpdate={(updated) => {
                            setEncabezado(updated);
                            form.setFieldsValue(updated);
                            setData((prev) => ({
                              ...prev,
                              results: (prev?.results || []).map((row) => (Number(row.id) === Number(updated.id) ? { ...row, ...updated } : row)),
                            }));
                          }}
                          onSetCalculando={setCalculando}
                          onSetOrigenesRecursos={setNominasOrigenesRecursos}
                          onCalculoTerminado={onCalculoTerminado}
                          periodosNominasDetalles={periodosNominasDetalles}
                          tiposNominasEmpleados={tiposNominasEmpleados}
                        />
                      ) : null}

                      {selectedRowKeys?.length ? (
                        <Table
                          data={nominasOrigenesRecursos}
                          cols={columnsNominasOrigenesRecursos}
                          permission={permission}
                        />
                      ) : null}

                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </Tabs.TabPane>

                  {/* ================= TAB FINANCIAMIENTO ================= */}
                  <Tabs.TabPane
                    tab="F. Financiamiento"
                    key="financiamiento"
                    disabled={!selectedRowKeys.length}
                    forceRender
                  >
                    <CalculoFuentesFinanciamiento
                      key={refreshKeyPostCalculo}
                      nominaId={selectedRowKeys[0]}
                      encabezado={encabezado}
                      // Solo se edita con la nómina Activa y abierta con "Editar".
                      soloConsulta={!nominaEditable}
                      permission={permission}
                    />
                  </Tabs.TabPane>

                  {/* ================= TAB RESUMEN ================= */}
                  <Tabs.TabPane
                    tab="Resumen"
                    key="resumen"
                    disabled={!selectedRowKeys.length}
                    forceRender
                  >
                    <NominaResumenViewer
                      // Sin nominaId en el key, el visor DevExpress (DxReportViewer) no se
                      // remonta al cambiar de Nomina seleccionada -- solo re-ejecuta
                      // ParametersInitialized (que es lo unico que reenvia el parametro
                      // "nomina" al reporte) cuando el componente se crea de cero, nunca en
                      // un re-render con props nuevas. Resultado real observado: al pasar de
                      // una Nomina a otra SIN que ocurra un recalculo (que si cambia
                      // refreshKeyPostCalculo), el reporte seguia mostrando los datos de la
                      // Nomina anterior.
                      key={`${selectedRowKeys[0]}-${refreshKeyPostCalculo}`}
                      nominaId={selectedRowKeys[0]}
                      isVisible={activeTabNomina === 'resumen'}
                    />
                  </Tabs.TabPane>
                  {/* ================= TAB PÓLIZAS ================= */}
                  <Tabs.TabPane
                    tab="Pólizas"
                    key="polizas"
                    disabled={!selectedRowKeys.length}
                    forceRender
                  >
                    <NominaPolizaViewer
                      // Ver comentario identico en NominaResumenViewer: el key debe incluir
                      // la Nomina seleccionada, no solo refreshKeyPostCalculo.
                      key={`${selectedRowKeys[0]}-${refreshKeyPostCalculo}`}
                      nominaId={selectedRowKeys[0]}
                      isVisible={activeTabNomina === 'polizas'}
                    />
                  </Tabs.TabPane>

                  {/* ================= TAB PRESUPUESTO ================= */}
                  <Tabs.TabPane
                    tab="Presupuesto"
                    key="presupuesto"
                    disabled={!selectedRowKeys.length}
                  >
                    <div style={{ padding: 16 }} />
                  </Tabs.TabPane>

                </Tabs>,
                'esta Nómina',
              )}
            </Card>
          </>
        )}
        {seguimiento.modalSeguimiento}
      </Spin>

      <ModalNuevoExcel
        visible={showNuevoExcelModal}
        onCancel={() => setShowNuevoExcelModal(false)}
        onConfirm={handleNuevoExcelExport}
        confirmText="Continuar: elegir columnas"
      />

      {/* Reporte de Nóminas: mismas funciones del Excel Personalizado, escrito agrupado por
          Departamento. reporteId propio para no mezclar sus configuraciones guardadas con las del
          Excel Personalizado de una sola nómina (misma URL). */}
      <ExportadorExcelPersonalizado
        visible={showExportadorReporteNominas}
        onCancel={() => setShowExportadorReporteNominas(false)}
        data={reporteNominas?.filas || []}
        titulosPorColumna={reporteNominas?.titulos || {}}
        formatosPorColumna={reporteNominas?.formatos || {}}
        columnasPorDefecto={reporteNominas?.columnasPorDefecto || []}
        agrupacion={reporteNominas ? {
          columna: 'departamento_reporte',
          etiqueta: 'Departamento',
          encabezado: reporteNominas.encabezado,
        } : null}
        reporteId="reporte-nominas"
        fileName={reporteNominas?.fileName || 'Nominas_Unificadas_PorArea'}
        sheetName="Nominas_Unificadas_PorArea"
      />

      <ModalNuevoExcel
        visible={showRetenidosModal}
        onCancel={() => setShowRetenidosModal(false)}
        onConfirm={handleRetenidosExport}
        title="Reporte de Depósito de Retenidos"
        confirmText="Generar Reporte"
      />

      {/* Sin reporteId: comparte las configuraciones guardadas con el Excel Personalizado del
          detalle de la nómina (misma URL y mismos datos). */}
      <ExportadorExcelPersonalizado
        visible={showExportadorPersonalizado}
        onCancel={() => setShowExportadorPersonalizado(false)}
        data={datosExportadorPersonalizado}
        fileName={`Nomina_${folioExportadorPersonalizado}_Personalizado_${moment().format('YYYY-MM-DD')}`}
        sheetName="NominaPersonalizado"
        titulosPorColumna={TITULOS_COLUMNAS_NOMINA}
      />

      <ModalConfirmation
        onFinish={onConfirmGuardarYRecalcular}
        Confirm
        onCancel={() => setVisibleGuardarYRecalcular(false)}
        open={visibleGuardarYRecalcular}
        contentTitle={`Guardar y Recalcular — Nómina ${encabezado?.numero_nomina}`}
        loading={loadingRecalcular}
      />
      <ModalConfirmation
        onFinish={onConfirmAuthorize}
        ConfirmAutorize
        onCancel={() => setVisibleConfirmAuthorize(false)}
        open={visibleConfirmAuthorize}
        contentTitle={`Autorizar la Nómina ${data?.results?.find((e) => e.id === selectedRowKeys[0])?.numero_nomina}`}

      />
      <ModalConfirmation
        onFinish={onConfirmCancelar}
        Confirm
        onCancel={() => setVisibleCancelar(false)}
        open={visibleCancelar}
        contentTitle={`Cancelar la Nómina ${data?.results?.find((e) => e.id === selectedRowKeys[0])?.numero_nomina}`}
        loading={loading}
      />
      <Modal
        visible={visibleErrores}
        title={(
          <Row justify="space-between">
            <Text style={{ fontSize: '1.25rem' }}>
              Historial de Errores
            </Text>
            <ModalErroresControls
              onCancel={() => setVisibleErrores(false)}
            />
          </Row>
        )}
        footer={null}
        closable={false}
        width="85%"
      >
        <Table
          cols={[{
            titleText: 'Descripción de Error',
            dataIndex: 'error',
            key: 'error',
            width: 200,
          }]}
          data={errores}
          mobileColIndex={0}
        />
      </Modal>
    </Row>
  );
};

export default CalculosDeNominaEncabezado;
